export const nl = {
    addDatabase: {
        addDatabase: "Database toevoegen",
        addFromFile: "Toevoegen vanaf bestand",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Alle verpakkingen",
        onePackage: "Ã©Ã©n verpakking",
        priceType: "Type prijs",
        setPriceVatVisibility: "Stel BTW zichtbaarheid in",
        setVisibilityAndOrder: "Stel zichtbaarheid in en prijstypes",
        withAndWithoutVat: "Met en zonder BTW",
        withVat: "Enkel met BTW",
        withoutVat: "Enkel zonder BTW"
    },
    barvis: {
        base: "Basis",
        bigCanSize: "Grote blikken",
        coating: "Verf",
        identifier: "Identificatie",
        laboratory: "Laboratorium",
        orderOverview: "Order overzicht",
        rank: "Rang",
        smallCanSize: "Kleine blikken"
    },
    basicSetup: {
        alreadyLoggedIn: "U bent reeds ingelogd als %{login}.",
        askSupplier: "Vraag uw software leverancier om meer licensies toe te kennen.",
        asterisk: "Items gemarkeerd met een asterisk moeten worden ingevuld.",
        identificationKeys: "Identificatiesleutels",
        importCustomData:
            "Importeer, indien van toepassing, uw aangepaste gegevens uit de vorige mengmachine software.",
        learnIdentification: "Leer de identificatiesleutels van uw softwareleverancier.",
        login: "Voor de volgende stappen van de eerste installatie zijn beheerdersrechten vereist.",
        noDatabase: "Er is nog geen database toegevoegd, er moet er minstens Ã©Ã©n worden ingevoegd.",
        offlineLicensing: "Offline licentie toewijzen",
        productSelection: "Product selectie",
        registrationForm: "Registratie formulier",
        seeQuestionMark: "Zie de kleine vraagtekens voor meer informatie over de instelling.",
        selectDefaultPrinter: "Selecteer de standaardprinter en stel aanvullende configuratie in.",
        selectDefaultTemplate:
            "Selecteer de standaardsjablonen uit de reeds bestaande, maak een nieuwe sjabloon of laad er zelf een.",
        selectDispenser: "Selecteer het type dispenser dat u gebruikt.",
        selectLanguage: "Selecteer uw taal.",
        selectProducts: "Selecteer een van de beschikbare producten die u wilt activeren.",
        selectSpectroType: "Selecteer het spectro-type dat u gebruikt.",
        setAdditionalPrinterOptions: "Stel extra printeropties in.",
        setAutomaticUpdates: "Stel de opties voor automatische updates in.",
        setCustomItems:
            "Stel de aangepaste items en de zichtbaarheid van gegevens in. Scroll naar beneden om meer opties te zien.",
        setEnvironment: "Stel de algehele omgeving van de software in. Scroll naar beneden om meer opties te zien.",
        setFormulaRepresentation: "Stel de formule-weergave in. Scroll naar beneden om meer opties te zien.",
        summary:
            "U kunt deze instellingen op elk moment wijzigen en nog meer configuratie-opties vinden. Veel plezier met het gebruik van %{name}!",
        summarySuccess: "Je bent helemaal klaar!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batchnummer: %{batchNumber}",
        colorantIsDefective: "Het canister is gevuld met een foutieve batch colorant. Gebruik deze batch niet.",
        defectiveInfoLine1: "Gebruik geen colorant",
        defectiveInfoLine2: "Met dit batchnummer",
        emptyQuickTint: "Canister leeg doseren met Quick tint",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Canisterniveau instellen",
        criticalLevelCanister: "Kritisch canisterniveau",
        fillToMax: "Vul tot maximaal niveau",
        maxDispenseLevel: "Doseer maximum",
        otherCanisters: "Andere canisters",
        warningLevelCanister: "Waarschuwing canister niveau"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Gevuld met batchnummer",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Beschikbare serviceacties",
        canisterInformation: "Canister informatie",
        canisterPreview: "Overzicht canister",
        currentLevel: "Huidig niveau",
        errors: "Fouten",
        fillState: "Vulstatus",
        fillToMax: "Vul tot maximaal niveau",
        fillingAmount: "Vulhoeveelheid",
        finalLevel: "Laatste niveau",
        minimumAmount: "Minimale hoeveelheid",
        minimumLevel: "Minimaal niveau",
        moveTableToRefill: "Draai tafel voor bijvullen",
        refillNoAmount: "Geen hoeveelheid ingegeven",
        refillOverLimit: "Ingegeven hoeveelheid overschrijdt maximale canister inhoud",
        refillSummary: "%{amount} %{unit} %{colorant} zal worden toegevoegd aan de canister %{canisterId}",
        systemWarningAmount: "Systeem waarschuwingsniveau",
        warningAmount: "Waarschuwingsniveau"
    },
    changeDatabase: {
        changeDatabase: "Database wijzigen",
        databaseWarning: "Database %{databaseName} kan niet gebruikt worden doorâ¦"
    },
    changelog: {
        allVersion: "Alle versies",
        changelog: "Wijzigingslog",
        link: "Link",
        links: "Links",
        version: "Versie",
        versionFilter: "Versie filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "Alle circuits reinigen",
        cleanChannels: "Reinig circuit",
        cleaningTime: "Tijd om te reinigen",
        selectChannels: "Selecteer circuit",
        startCleaning: "Reinigen starten"
    },
    clientServerSettings: {
        activeServer: "Actieve server",
        addNewServer: "Nieuwe server toevoegen",
        availableServers: "Andere beschikbare servers",
        clientIdentifier: "Klant identificatie",
        clientServerSettings: "Klant-/serverinstellingen",
        disabledStatus: "Uitgeschakeld",
        editServer: "Server bewerken",
        fillRequiredFields: "Verplichte velden moeten worden ingevuld",
        noOtherServers: "Er zijn geen andere beschikbare servers",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "Poort",
        serverName: "Naam server",
        serverNameMissing: "Servernaam moet worden ingevuld",
        stabileConnection: "Gebruik een stabiel IP-adres om een stabiele verbinding te garanderen.",
        wrongFormatIp: "Verkeerd IP-adresformaat"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Kleur toon",
        fandeckPosition: "Kleurenwaaier positie",
        moreInfoIcons: "Meer informatie",
        notExistingFormula: "Formule bestaat niet",
        orderBy: "Bestelling door",
        selectYourGrid: "Selecteer uw raster",
        showInPanel: "Filteren op",
        warningIcon: "Formule bestaat niet waarschuwend icoon"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Gebruik batchnummer op percentage",
        batchNumberFromLastFilling: "Gebruik batchnummer van de laatste vulling",
        defectiveBatchOfColorant: "Foutieve colorant batch",
        enableBatchNumber: "Inschakelen colorant batchnummers",
        possibleDamagedBatchOfColorant: "Mogelijke foutieve colorant batch",
        scanOrTypeBatchNumber: "Scan of type het batchnummer"
    },
    colorantPanel: {
        manualMachine: "Machine"
    },
    colorantsTable: {
        numberOfColorants: "Aantal kleurpasta's:",
        preview: "Voorbeeld",
        prices: "Prijzen"
    },
    currencySettings: {
        addNewCurrency: "Nieuwe valuta toevoegen",
        codePlaceholder: "Code",
        currencySettings: "Valuta-instellingen",
        namePlaceholder: "Naam",
        ratePlaceholder: "Tarief",
        setDecimalPlaces: "Aantal cijfers na de komma instellen",
        setMainCurrency: "Basis valuta instellen",
        setRounding: "Afronding instellen",
        symbolPlaceholder: "Symbool"
    },
    customFandecks: {
        customFandecks: "Kleurenwaaiers op maat",
        deleteButtonWarning: "Alle formules in de waaier zullen ook verwijderd worden",
        deleteCustomFandeck:
            "Wilt u deze aangepaste waaier echt verwijderen? Alle formules in deze waaier worden verwijderd.",
        disableStandardFandecks: "Toon alleen aangepaste kleurenwaaiers weergeven",
        enableStandardFandecks: "Toon standaard kleurenwaaiers",
        fandeckName: "Naam kleurenwaaier"
    },
    customRedlike: {
        addColorantFromBrand: "Voeg colorant toe van %{brandName} merk",
        addNewCustomer: "Nieuwe klant toevoegen",
        addNewNote: "Nieuwe opmerking toevoegen",
        addedDate: "Toegevoegde datum",
        addedQuantity: "Toegevoegde hoeveelheid",
        availableMachine: "Machine beschikbaar",
        brand: "Merk",
        brandPlease: "Selecteer merk",
        cancelCustomer: "Annuleer klant",
        colorPlease: "Selecteer kleur",
        confirmCustomerData: "Klantgegevens bevestigen",
        confirmNoteData: "Gegevens opmerking bevestigen",
        confirmSelectedUser: "Wilt u klant %{customerName} gebruiken voor dit order",
        confirmed: "Bevestigd",
        controlData: "Laatste controle gegevens",
        customerCellNumber: "Gsm-nummer klant",
        customerFilter: "Filter klant",
        customerName: "Naam klant",
        customerPhone: "Telefoonnummer klant",
        customerPlease: "Selecteer klant",
        dateFilter: "Filter datum",
        enterPin: "Voer je pincode in",
        enterTheNumberOfPackages: "Voer het aantal verpakkingen in",
        existingCustomer: "Gebruiker bestaat al",
        fandeckPlease: "Selecteer kleurenwaaier",
        fillCanisterHistory: "Canister vulgeschiedenis",
        findCustomer: "Scan de barcode of zoek een e-mailadres om een klantenkaart aan deze bestelling toe te wijzen",
        findCustomerByEmail: "Filter klant door email of barcode",
        finishPreviousStep: "(Werk de vorige stap af)",
        formulaUnit: "Formule-eenheid",
        getBackToList: "Ga terug naar de klantenlijst",
        historyOfOrders: "Opdrachtgeschiedenis",
        insertNote: "Ga naar 'Opmerking plaatsen'",
        loadHistoryOrder: "Wilt u een geselecteerde opdracht laden?",
        loyaltyCards: "Klanten kaarten",
        machineIsAvailable: "MACHINE IS BESCHIKBAAR",
        machineIsUnavailable: "MACHINE IS NIET BESCHIKBAAR",
        newLoyaltyCard: "Nieuwe klantenkaart",
        noAvailableMachine: "Machine is niet beschikbaar",
        noCustomerSelected: "Er is geen klant geselecteerd. Wil je doorgaan?",
        notePlease: "Voeg een opmerking in",
        openHistory: "Open geschiedenis",
        orAdd: "Of voeg klant toe",
        orSelect: "Of selecteer klant",
        orderModification: "De oorspronkelijke volgorde wordt gewijzigd. Wil je doorgaan?",
        orderOverview: "Opdrachtoverzicht",
        orderToMachine: "Verstuur opdracht",
        ordersHistory: "Bestelling historiek",
        packagePlease: "Selecteer verpakking",
        pleaseSelectBrand: "Selecteer merk",
        previewImage: "Voorbeeld afbeelding",
        previewPackage: "Voorbeeld van verpakking",
        productPlease: "Selecteer product",
        resetFilters: "Reset alle filters",
        searchForHistoricalOrders: "Zoek opdrachten in de geschiedenis",
        selectBrand: "Selecteer merk",
        selectColor: "Ga naar kleur selecteren",
        selectCustomer: "Ga naar klant selecteren",
        selectExistingCustomer: "Selecteer bestaande klant",
        selectFandeck: "Ga naar kleurwaaier selecteren",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Ga naar verpakking selecteren",
        selectProduct: "Ga naar producten selecteren",
        shotsCoefficient: "Shots verhouding",
        showDetail: "Toon detail",
        showHideEshopName: "Toon / verberg de eshop-naam van de kleur in een aparte kolom",
        showKeyboard: "Toetsenbord tonen",
        skipCustomerButton: "Sla 'Klant selecteren' over",
        skipCustomerText: "Overslaan als u geen klant wil invoeren",
        skipNote: "Sla opmerking over en bekijk overzicht",
        spectroBrand: "Zoeken in merk %{brandName}",
        statusAccepted: "Geaccepteerd",
        statusCanceled: "Geannuleerd",
        statusCreated: "Aangemaakt",
        statusDone: "Gedaan",
        statusPartlyDone: "Gedeeltelijk gedaan",
        statusPreparing: "Voorbereiding",
        summaryChosenBase: "Basisverf",
        summaryChosenBrand: "Merk",
        summaryChosenCanSize: "Blikformaat",
        summaryChosenColor: "Kleur",
        summaryChosenColorCard: "Kleurkaart",
        summaryChosenProduct: "Product",
        summaryChosenQuantity: "Aantal",
        summaryColorPreview: "Kleurvoorbeeld",
        summaryCustomNote: "Klant opmerking",
        summaryCustomerNumber: "Klantnummer",
        summaryFormula: "Formule",
        summaryFormulaNote: "Formule opmerking",
        summaryNote: "Opmerking",
        sureAboutSend: "Weet je zeker dat je een opdracht wilt verzenden?",
        useCustomerInOrder: "Wilt u %{customerName} in de volgende order gebruiken?",
        uuid: "Server database- en licentiegegevens",
        viewSummary: "Overzicht bekijken",
        volume: "Inhoud"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Code Opdrachtbevestiging",
        pinScreenSaverConfirmation: "Code bevestiging screensaver",
        pinSettingsConfirmation: "Code bevestiging instellingen",
        printAuto: "Automatisch printen toestaan",
        printerSettings: "Printerinstellingen",
        selectColorWithFandeck: "Algemene selectie van kleur en waaier",
        setKeyboard: "Toetsenbord instellen",
        setKioskMode: "Stel kiosk modus in",
        setLanguage: "Stel taal in",
        setModule: "Stel module in",
        setQuickSelect: "Stel snelle keuze in",
        setScreensaverTimeout: "Time-out screensaver instellen",
        setUnit: "Eenheid instellen"
    },
    customRedlikeMachine: {
        action: "Actie",
        additionalPrint: "Extra print",
        brand: "Merk",
        brandAccess: "Gebruiker '%{userName}' heeft geen toegang tot data van merk '%{brandName}'",
        can: "Blik geplaatst",
        canistersLevel: "Overzicht canisterniveaus",
        closeDetailInformation: "Detail sluiten",
        colorantsAmount: "Kleurpasta niveau",
        confirmRefill: "Bevestig bijvullen",
        deleteOrder: "Opdracht verwijderen",
        dialogNoMachine: "Machine is niet verbonden",
        dialogNoRcc: "RCC is niet verbonden",
        dispense: "Doseren",
        dispenserInErrorState: "Er is een storing opgetreden, druk reset",
        dispensingIsOk: "Dispenser OK",
        emergencyButtonPressed: "Noodknop ingedrukt",
        errorCode: "Foutcode",
        errorEvents: "Dispenser fouten",
        errorReset: "Reset Fout",
        explanation: "Uitleg",
        imageNotAvailable: "Afbeelding is niet beschikbaar",
        incorrectCanister: "Verkeerd canister gescand!",
        incorrectColorant: "FOUT: Verkeerde kleurpasta gescand. Scan de juiste pasta",
        lastEvents: "Laatste acties",
        machineActions: "Sensoren doseermachine",
        machineConfiguration: "Dispenser configuratie",
        machineError: "Machinefout",
        machineIsBusy: "Machine is bezig",
        machineNotAvailable: "Machine is niet beschikbaar",
        machineTinting: "Wacht aub, machine aan het doseren...",
        manualScan: "Handmatig scannen",
        notEnoughSpace: "FOUT: De hoeveelheid kleurpasta in dit blik kan nu niet worden bijgevuld",
        numberOfCanistersUnderCriticalLevel: "Het aantal canisters onder het kritische niveau is %{0}",
        numberOfCanistersUnderWarningLevel: "Het aantal canisters onder het waarschuwing niveau is %{0}",
        offlinePressed: "Offline knop ingedrukt",
        orderSettings: "Bestelinstellingen",
        otherOrderInformation: "Besteldetail",
        packageCount: "Aantal",
        packageWithSeparator: "Verpakking",
        received: "Ontvangen",
        receivedOrders: "Ontvangen opdrachten",
        receivedTime: "Tijd ontvangst",
        recirculation: "Recirculatie",
        refillInformation: "Kleurpasta: %{0}, Vulniveau: %{1}, Canister: %{2}",
        resetErrors: "Reset",
        scanCanister: "Scan deze canister",
        scanColorantPackage: "Scan het juiste kleurpasta blik",
        selectedOrder: "Geselecteerde opdracht",
        shelfMovingDown: "Bliktafel naar beneden",
        shelfMovingUp: "Bliktafel naar boven",
        solution: "Oplossing",
        startDispensing: "Start dosering",
        stirring: "Roeren",
        touchToStartFilling: "Druk hier om kleurpasta bij te vullen",
        unknownBrand: "Onbekend merk"
    },
    customRedlikeSettings: {
        addPos: "POS informatie",
        addServer: "Voeg server toe",
        adminOperations: "Admin handelingen",
        adminSettings: "Admin instellingen",
        another: "Andere",
        aslOrService: "ASL of service",
        availableMachines: "Beschikbare machines",
        barcode: "Barcode",
        basicOperations: "Basis handelingen",
        canisterBarcodes: "Canister barcode",
        canisterLevels: "Canister niveaus",
        closeConnection: "Sluit connectie",
        closeRedlike: "Sluit %{name}",
        databaseList: "Databases",
        disabledStatus: "Uitgeschakeld",
        dispenseLogicType: "Doseer type",
        dropServers: "Verwijder servers",
        editServer: "Pas server aan",
        lastEvent: "Laatste gebeurtenis",
        logOut: "Uitloggen",
        machineConfiguration: "Configuratie",
        maxDispenseAmount: "Doseer maximum hoeveelheid",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        openFrondesk: "Open voorfront",
        print: "Printerinstellingen",
        rebootPC: "Computer herstarten",
        restartRedlike: "%{name} heropstarten",
        restoreConnection: "Herstel verbinding",
        scanCanisterBarcode: "Scan barcode van canister",
        scanOrDeleteCanisterBarcode: "Scan of annuleer barcode",
        setCanisterBarcode: "Stel canister barcode in",
        swVersion: "Software versie",
        systemFunctions: "Systeemfuncties",
        userSettings: "Gebruikers instellingen"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Kleur bewerken",
        editColorant: "Kleurpasta bewerken",
        emptyColorant: "Een kleurpasta bevat geen hoeveelheid",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formule voor moederproduct",
        formulaForMasterProductWithParam: "Formule voor moederproduct %{productName}",
        isNotAvailable: "Is niet beschikbaar",
        noBaseSelected: "Basis is nodig",
        noColorantsSelected: "Geen kleurpasta geselecteerd",
        noFandeckSelected: "Kleurenwaaier vereist",
        noNameOrCode: "Kleur naam en kleurcode vereist",
        noProductSelected: "Product vereist",
        productPreview: "Voorbeeld product",
        saveCustomRecipe: "Klant recept opslaan",
        saveIsNotAvailable: "Opslaan niet mogelijk",
        showSiblingProducts: "Toon verwante producten",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Klant toevoegen",
        additionalSettings: "Aanvullende instellingen",
        adress: "Adres",
        createAndSelect: "Voeg toe en selecteer",
        createNewCustomer: "Maak een nieuwe klant",
        editCustomer: "Klant bewerken",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identificatie nummer",
        information: "Contact informatie",
        listOfCustomers: "Klantlijst",
        rabat: "Korting",
        selectCustomer: "Selecteer klant",
        spentLastMonth: "Uitgegeven vorige maand",
        spentMoney: "Uigegeven bedrag",
        typeOfMargin: "Soort marge",
        zipCode: "Postcode"
    },
    dialog: {
        cheaperColorSearch: "Zoeken van goedkopere formulering is bezig",
        competitiveColorSearch: "Gelijkwaardige kleur zoekopdracht bezig",
        reallyChangeModule: "Bent u zeker dat u de module wilt wijzigen?",
        reallyCloseRedlike:
            "Wilt u klant %{name} sluiten? Alle %{name} vensters zullen gesloten worden, niet opgeslagen wijzigingen zullen verloren gaan.",
        reallyDeleteOrder:
            "Bent u zeker dat u deze Opdracht wilt verwijderen? Alle gegevens over deze Opdracht zullen verloren gaan.",
        reallyRebootPC:
            "Bent u zeker dat u deze pc wil herstarten? Alle schermen worden afgesloten en niet opgeslagen gegevens zullen verloren gaan.",
        reallyRestartRedlike:
            "Bent u zeker dat u %{name} wilt herstarten? Alle schermen worden afgesloten en niet opgeslagen gegevens zullen verloren gaan.",
        reallyShutdownPc:
            "Wilt u de computer afsluiten? Alle %{name} vensters zullen gesloten worden, niet opgeslagen wijzigingen zullen verloren gaan.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Doseer enkel maximum toegelaten hoeveelheid",
        2: "Toestaan manueel doseren voorbij maximum doseerhoeveelheid",
        3: "Aanvulling tijdens doseren ",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Naam kleurenwaaier"
    },
    editFormulaRgbModal: {
        apply: "Toepassen",
        blue: "Blauw",
        green: "Groen",
        modalLabel: "Kleur bewerken",
        red: "Rood",
        tryGenerateRgb: "Genereer RGB waarde op basis van colorant hoeveelheid"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Automatisch sluiten van formule blad",
        allowBarcodes: "Sta barcodes toe",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Sta klanten toe",
        allowDeleteConfirmation: "Bevestiging verwijderen toestaan",
        allowDiskSpaceNotification: "Sta schijfruimte notificatie toe",
        allowDispensing: "Sta purgeren toe",
        allowFileTransfer: "Sta automatische bestandsoverdracht toe",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Sta formule paneel status toe",
        allowInternalNotes: "Sta interne notities toe",
        allowLight: "Toestaan %{name}",
        allowOrderNotificationModal: "Toon meldingen van nieuwe orders",
        allowOrdering: "Sta wachtrij toe",
        allowPricing: "Sta prijszetting toe",
        allowPrint: "sta print toe",
        allowProductPreviewImage: "Toestaan product afbeelding tijdens doseren",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Sta zoeken naar goedkopere formuleringen toe",
        allowSound: "Sta alarm signaal toe",
        allowSpectro: "Spectro toestaan",
        allowTabs: "Tabbladen toestaan",
        applyZoom: "Zoomen",
        automaticLogout: "Automatisch uitloggen",
        barcodeScan: "Scan barcode",
        canisterBarcode: "Barcodes canisters",
        canisterLevel: "Canister niveau",
        changelog: "Wijzigingslogboek",
        closeTab: "Sluit tabblad",
        colorDifference: "Color difference",
        colorPanelNavItem: "Kleuren pallet",
        competitiveColorSearch: "Gelijkwaardige kleur zoeken",
        customBanner: "Aangepaste banner",
        customCurrencyFormat: "Koersformat",
        customDateFormat: "Datum format",
        customNumberFormat: "Nummer format",
        customTimeFormat: "Tijd format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Toon korting",
        dispensingHistory: "Doseergeschiedenis",
        dispensingNotes: "Sta doseer notities toe",
        enableCustomers: "Klanten inschakelen",
        enableDeleteConfirmation: "Schakel verwijderbevestiging in",
        enableDispensing: "Toestaan purgeren",
        enableLight: "Toestaan %{name}",
        enableMarginMarkup: "Marge inschakelen of Markup",
        enableNotes: "Schakel notities in",
        enableOrdering: "Schakel wachtrij in",
        enableProductPreviewImage: "Schakel product afbeelding in",
        enableSpectro: "Schakel spectro in",
        enableVirtualKeyboard: "Sta virtueel toetsenbord toe",
        environmentsSettings: "Omgevingsinstellingen",
        exportTranslationKeys: "Exporteer vertaalsleutels",
        formulaNotes: "Sta formule notities toe",
        hintTooltips: "Tip tooltips",
        image: "Afbeelding",
        keyboardShortcuts: "Toetsenbord shortcuts",
        languageBased: "Taal gebaseerd",
        lockYourComputer: "Vergrendel uw computer",
        machineReset: "Machine reset",
        manageTranslations: "Beheer vertalingen",
        margin: "Enkel marge",
        markup: "Enkel Markup",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maximum hoeveelheid formule tabbladen",
        memoryTabs: "Sla recent geopende tabbladen op",
        moreInfo: "Kleur+Afbeelding+meer informatie",
        navigationItems: "Navigatie instellingen",
        newTab: "Nieuw tabblad",
        numberOfPriceGroups: "Aantal prijsgroepen",
        order: "Bestelling",
        orderId: "Bestelling ID",
        ordersHistory: "Historie orders",
        overwriteLastTab: "Overschrijf laatste formule tabblad",
        priceCalculation: "Prijs calculatie",
        priceDefBothPurchasePrimary: "Beide, koop primair",
        priceDefBothSellPrimary: "Beide, verkoop primair",
        priceDefPurchaseOnly: "Alleen inkoopprijs",
        priceDefSellOnly: "Alleen verkoopprijs",
        priceDefinition: "Prijs definitie",
        priceGroupsEnabled: "Toestaan van prijsgroepen",
        runLightAtStartUp: "Start %{light} bij opstarten",
        screenSaverTimeout: "Time-out van screensaver",
        selectedSpectro: "%{spectro} spectro geselecteerd.",
        selectedSpectroNone: "Geen spectro geselecteerd",
        setAutomaticClientStart: "Voer %{name} uit bij het opstarten van de computer",
        setCustomHomeButton: "Stel Home actie knop in",
        setDecimalPlaces: "Aantal cijfers na de komma instellen",
        setFormulaPreview: "Formulevoorbeeld finstellen",
        setFormulaUnit: "Stel formule eenheid in",
        setFts: "Gebruik volledige tekst zoekfunctie",
        setInfoItemInRgb: "Stel zichtbare informatie in de formule RGB-preview in",
        setKeyboardShortcuts: "Stel toetsenbord shortcuts in",
        setKioskMode: "Stel kiosk modus in",
        setKioskModeOff: "Zet kiosk modus uit",
        setKioskModeOn: "Zet kiosk modus aan",
        setNavigationItems: "Zoek-items instellen",
        setNavigationItemsList: "Stel zichtbaarheid en volgorde navigatie in",
        setOrderSearchItems: "Stel zoekfunctie orders in",
        setRounding: "Afronding instellen",
        setSearchParameters: "Stel formule in voor zoek parameters",
        setTabLimit: "Stel maximum aantal tabbladen in",
        setYourLanguage: "Taal instellen",
        setZoom: "Zoomen instellen",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Deze instelling kan niet worden gewijzigd, omdat het dialoogvenster Plaats kan zijn gedeactiveerd in Machine-instellingen",
        sortItems: "Sorteer navigatie",
        startDispensing: "Start met doseren",
        stir: "Roer"
    },
    error: {
        errorDetail: "Detail foutmelding",
        errorOccurred:
            "Een onverwachte foutmelding heeft plaatsgevonden. Laat een bericht achter bij onze supportdienst via %{0}, en we nemen zo snel mogelijk contact met u op.",
        hideDetail: "Detail verbergen"
    },
    favoritesTab: {
        addFolder: "Map toevoegen",
        closeTabToLoadFormula:
            "Sluit een van de formules om een nieuw tabblad te openen. U hebt het maximale aantal tabbladen bereikt.",
        deleteFolder: "Map verwijderen",
        editFolder: "Map bewerken",
        favoriteFormulas: "Favoriete formules",
        formulaNotes: "Formule notities",
        message: {
            formulasFromFolder: "Formules uit map",
            moveAllFormulas: "Verplaats alle formules naar de moeder database",
            removeAllFormulas: "Verwijder alle formules uit deze map",
            wantToDeleteFolder: "Bent u zeker dat u deze map wil verwijderen?"
        },
        newFolder: "Nieuwe map",
        packages: "Verpakkingen",
        pricePerPackage: "Prijs per verpakking",
        regularPrice: "Normale prijs",
        removeFromFavorites: "Verwijderen uit favorieten",
        specialPriceOff: "Speciale prijs %{number}% korting",
        specialPriceVIP: "Speciale VIP-prijs"
    },
    fileTransfer: {
        afterImport: "Na import",
        alreadyExists: "Taak voor type/format bestaat al",
        customFormulaSimple: "Klant formulering (eenvoudig)",
        direction: "Directie",
        exportTask: "Bestands export opdracht",
        fileTransferNotification: "Bestands overdracht notificatie",
        flashMessage: "pop-up bericht",
        importTask: "Bestands import opdracht",
        noInformation: "Geen informatie",
        protocol: {
            folder: "Map",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP-opslagprotocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocolcontrolebestanden in gedefinieerde lokale map",
            ftp: "Protocolcontrole van bestanden in externe FTP-map met behulp van standaard FTP-verbinding.",
            ftps: "Protocolcontrole van bestanden op een externe FTPS-server (FTP-SSL / FTP Secure) met behulp van een standaard FTP-verbinding.",
            redlikeStorage: "Protocolcontrolebestanden in %{softwareName}-opslag."
        },
        remoteFolder: "Externe map",
        startType: "Begintype",
        statusbar: "Statusbar informatie",
        testConnection: "Test verbinding",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Soort verbruik",
        filter: "Filter",
        from: "Van",
        to: "Tot"
    },
    findText: {
        findTextTitle: "Zoek tekst",
        removeMarks: "Verwijder markeringen",
        search: "Zoek woord"
    },
    flashMessage: {
        VMNotAllowed: "Virtuele machine niet toegestaan",
        addedToStock: "Artikelen zijn aan de voorraad toegevoegd",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Automatisch aanmelden bij database is mislukt",
        autotaskDuplicateName:
            "Database integriteitsfout : %{0} object met %{1} %{2} bestaat reeds, gebruik andere %{3}",
        barcodeIsUsed: "De barcode is reeds gebruikt",
        barcodeNotFound: "De barcode werd niet gevonden",
        bugReportSent: "Fout rapport werd verzonden",
        cannoctConnectToServer: "Kan geen verbinding maken met de server",
        cannotWriteLicense: "Kan geen licentie schrijven",
        clientConnectionRejected: "Verbinding afgewezen",
        clientNotLoggedIn: "Klant is niet ingelogd",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorantverpakking verwijderd uit de voorraad.",
        competitiveSearchEmpty:
            "Er konden geen concurrerende kleuren worden gevonden. Wijzig zoekopdracht of selecteer een andere kleur.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Verouderde computer",
        connectionFailed: "Verbindingstest mislukt: %{0}",
        connectionSuccess: 'Verbindingstest"',
        corruptedLicenseFile: "Licensiebestand beschadigd",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Klant werd niet gevonden",
        dataNotAvailable: "Server kan geen verbinding maken met de database",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Een onverwachte foutmelding heeft plaatsgevonden tijdens de laatste serveractie",
        deleteAll: "Wis alles",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "U kunt de winter plug-in uitschakelen met behulp van de vervolgkeuzelijst aan de rechterkant van de tabbladnavigatie",
        duplicateBarcode: "Er bestaat al een dubbele streepjescode.",
        duplicateName: "Deze naam is al in gebruik",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "Er zijn geen voorraad voor het artikel dat u heeft gebruikt.",
        expiredLicense: "Licentie is verlopen",
        exportSuccess: "Data werd succesvol geÃ«xporteerd",
        fandeckExist: "Deze kleurenwaaier naam bestaat reeds",
        featureNotAutorized: "Functie niet geautoriseerd",
        fileExportComplete: "Bestand is succesvol geÃ«xporteerd.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Bestand is leeg of niet toegewezen.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Data in bestand kan niet worden verwerkt. Bestand is niet geldig.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Kan versie van bestand niet detecteren.",
        filetransferNoData: "Geen database connectie. Controleer de instellingen.",
        formulaDataUnavailable: "Formule niet beschikbaar",
        helperDefaultMessage: "Er is een onverwachte fout opgetreden tijdens de laatste Helper Server-actie",
        helperServerError: "Helper server fout",
        importAborted: "Import proces werd gestopt",
        importSuccess: "Data werd succesvol geÃ¯mporteerd",
        incompatibleBaseCan: "Het basis blik is niet compatibel met het product, de basisverf en de verpakking",
        incorrectPassword: "Oude wachtwoord is niet correct, voer een correct wachtwoord in",
        invalidCurrency: "Valuta is niet correct. Euro is ingesteld als standaard valuta.",
        invalidDatabaseName: "Ongeldige database naam",
        invalidEmail: "Uw e-mail is niet geldig",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Ongeldige gebruikerscode",
        invalidLicenseFile: "Ongeldige licentie",
        invalidLicenseIdentificationKeys: "Ongeldige licentiesleutel",
        invalidLicenseKey: "Uw licentie is niet geldig",
        invalidLicenseProduct: "Licentie bestand past niet bij product",
        invalidRccResponse: "Er is een onverwachte fout opgetreden tijdens de verwerking van de laatste RCC-reactie",
        invalidServerResponse:
            "Een onverwachte foutmelding heeft plaatsgevonden tijdens de verwerking van de laatste serveractie",
        invalidUrl: "URL is niet geldig",
        itemNotFound: "Het item werd niet gevonden",
        keyboardShortcutUsedInModal:
            "Deze sneltoets kan niet worden gebruikt in het pop-up venster. Sluit het pop-up venster.",
        keyboardShortcutValidation:
            "Het is niet mogelijk om 2 verschillende acties op Ã©Ã©n toetsenbord shortcut te plaatsen",
        licenseHasBeenRevoked:
            "Uw licentie is ingetrokken. Neem contact op met uw softwareleverancier om deze te verlengen.",
        licenseProlongationNeeded:
            "Verlenging van licentie nodig (verbind pc met internet om nieuwe licentie te verkrijgen)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Originele licentie op een andere computer",
        logFileArchiveDownloadComplete: "Het downloaden van het logboekarchief is voltooid",
        loginError: "Een onverwachte foutmelding heeft plaatsgevonden tijdens het aanmelden",
        logoutError: "Een onverwachte foutmelding heeft plaatsgevonden tijdens het afmelden",
        machineIsConnecting: "Machine wordt geconnecteerd, gelieve even te wachten",
        machineIsNotConnected:
            "De verfmengmachine is niet aangesloten op Redlike Control Center. Controleer de RCC configuratie",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maximaal aantal tabbladen open. Sluit een tabblad.",
        noTemplate: "Afdrukken kan niet worden uitgevoerd omdat er geen sjablonen beschikbaar zijn.",
        openNewTab: "Open een nieuw formuleblad om de formule met barcode te laden",
        orderAlreadyAcquired: "Bestelling is al verworven, deze moet eerst worden vrijgegeven",
        orderCreated: "Opdracht verzonden",
        passwordIsNotUnique: "Het nieuwe wachtwoord mag niet overeenkomen met voorgaand wachtwoord.",
        printCannotBeCarriedOut: "Afdrukken kan niet worden uitgevoerd om dat de printernaam ongeldig is.",
        problemWithFileExport: "Helaas is er een probleem opgetreden bij het opslaan van het logboekarchief.",
        productFileWarning: "Product bestanden zijn alleen online beschikbaar",
        productNotLicensed: "Product heeft geen licentie",
        rccDefaultMessage: "Een onverwachte foutmelding heeft plaatsgevonden tijdens de laatste RCC-actie",
        rccError: "RCC-fout",
        rccNeedRestart: "Herstart uw RCC",
        restoredSettings: "Instellingen zijn hersteld",
        revokedLicense: "Licentie werd ingetrokken",
        runningOutOfSpace: "Er is bijna geen vrije ruimte meer beschikbaar op uw computer.",
        savedFormulaToHistory: "Formule werd succesvol opgeslagen",
        savedLogArchive: "Logboekarchief is succesvol opgeslagen in uw map.",
        scanning: "Bezig met scannen",
        serverError: "Server fout",
        setClientIdentifier: "Stel uw klant-ID in",
        showLess: "Toon minder",
        showMore: "Toon meer",
        spectroIsDisconnecting: "Spectro is niet geconnecteerd, gelieve even te wachten",
        spectroIsNotConnected: "Uw spectro is NIET VERBONDEN op dit moment Controleer de RCC-configuratie.",
        spectroIsNotSelected: "Uw spectro is NIET GESELECTEERD op dit moment. Controleer de RCC-configuratie.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Onbekende fout: %{0}",
        userAlreadyLoggedIn: "U bent reeds ingelogd!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Kan geen vernbinding maken met Web Api server",
        webApiInternalError: "Web Api server interne fout",
        webApiInvalidUser: "Web Api server ongeldige gebruiker",
        webApiNoLicenseAvailable: "Web Api server geen licentie beschikbaar",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Verkeerd ontwerp input %{0}.",
        wrongRccVersion: "Controleer de versie van uw RCC. Uw klant is enkel compatibel met RCC %{0}."
    },
    footer: {
        aboutApplication: "Over de toepassing",
        activeUser: "Actieve gebruiker",
        logOut: "Afmelden",
        machineErrors: "Machinefouten"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Alle eenheden die beschikbaar zijn",
        allowCustomFormulas: "Sta klant formules toe",
        allowCustomPackageSize: "Sta aangepaste klant verpakking toe",
        allowFormulaAutomaticNaming: "Automatische naamgeving toestaan",
        automaticNaming: "Formule automatische naamgeving",
        basePanelSize: "Stel de grootte in van basis paneel",
        bippPanelSize: "Stel de grootte in van basis in productverpakking paneel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Kleuren pallet",
        colorPreviewAsImage: "Kleur preview als afbeelding",
        colorPreviewResizable: "Aanpasbare kleur preview",
        competitiveColorSearch: "Zoek concurrerende kleur",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Klant formules",
        customPackageSettingsUnitGrav: "Aangepaste verpakking (gravimetrisch)",
        customPackageSettingsUnitVol: "Aangepaste verpakking (volumetrisch)",
        customPackageSize: "Stel aangepaste klant verpakking in",
        customUnits: "Kies aangepaste eenheden",
        dropDownCalculate: "Vouw het vervolgkeuzemenu uit tot de hoogte van het venster",
        editColorants: "Wijzig kleurpasta's",
        editColorantsAllowed: "Sta wijzinging kleurpasta's toe",
        fandeckPanelSize: "Stel grootte van kleurenwaaier paneel in",
        favoriteFormulas: "Favoriete formules",
        formulaColorPreview: "Voorbeeld kleurformule",
        formulaDataSettings: "Instellingen formule",
        formulaPanel: "Formulevenster",
        formulaPanelSize: "Stel de grootte van formule paneel in",
        formulaSettings: "Instellingen formule",
        generateColorPreview: "Genereer kleur preview",
        gravimetricOnly: "Alleen gravimetrische eenheden",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Gebruik alleen afbeeldingen van de locale database",
        imagesOnline: "Open in eerste instantie de online afbeelding. Indien dit niet werkt open de locale afbeelding",
        infoPanelResizable: "Aanpasbaar Meer info paneel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Eenheid is afhankelijk van het geselecteerde product",
        productFilesDialog: "Dialoogvenster weergeven om lokaal of online bestand te openen",
        productFilesLocal: "Gebruik alleen producten van de locale database",
        productFilesOnline:
            "Open in eerste instantie de online producten bestand. Indien dit niet werkt open de locale bestanden.",
        productPanelSize: "Stel grootte van kleur paneel in",
        searchPanelQuickSelect: "Snel selecteren",
        setAdditionalFormulaPanel: "Stel extra formulepaneel in",
        setCompetitiveColorSearch: "Sta competitieve kleur zoek opdracht toe",
        setInitialFormulaPanel: "Initieel formulevenster instellen",
        setMaxToleranceForCompetitiveColors: "Stel maximale tolerantie in voor concurrerend zoeken in kleur",
        setNumberOfCompetitiveColors: "Aantal concurrerende moederkleuren instellen",
        setSearchPanel: "Zoekvenster instellen",
        setVisibilityAndOrder: "Stel de zichtbaarheid en volgorde van verschillende formulegegevens in",
        setVisibleUnit: "Stel zichtbare eenheden in",
        showColorPreview: "Voorbeeld kleur tonen",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Sorteer colorant",
        useBase: "Gebruik selectie-item voor basis",
        useBaseInProductPackage: "Gebruik selectie-item voor basis in productpakket",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Gebruik selectie-item voor product",
        useProductCode: "Gebruik productcode",
        useProductGroups: "Gebruik product groepen",
        volumetricOnly: "Alleen volumetrische eenheden"
    },
    general: {
        accepted: "Accepted",
        active: "Laatste activiteit",
        actual: "Huidig",
        actualLevel: "Huidig niveau",
        add: "Toevoegen",
        addColorant: "Kleurpasta toevoegen",
        addColorantForPackage: "Kleurpasta toevoegen van Ã©Ã©n verpakking",
        addFile: "Bestand toevoegen",
        all: "Alle",
        amount: "Aantal",
        applyNow: "Apply now",
        attachments: "Bijlagen",
        automaticCorrection: "Automatic correction",
        automatically: "Automatisch",
        available: "Beschikbaar",
        back: "Terug",
        base: "Basisverf",
        baseInProductPackage: "Basis in product en verpakking",
        batchNumber: "Batchnummer",
        bottom: "Onderaan",
        buildingSite: "Building site",
        calculate: "Bereken",
        can: "Blik",
        canSize: "Blik formaat",
        cancel: "Annuleren",
        canister: "Canister",
        canisterId: "Canisternummer",
        canisterIndex: "Canister index",
        canisters: "Canisters",
        cap: "Afsluiter",
        capacity: "Capaciteit",
        channels: "Circuits",
        choose: "Kies",
        city: "Stad",
        clean: "Maak schoon",
        clear: "Transparant",
        client: "Klant",
        close: "Sluiten",
        closeAll: "Sluit alles",
        collapseAll: "Alles inklappen",
        color: "Kleur",
        colorCode: "Kleur code",
        colorFile: "Colorfile",
        colorName: "Kleur naam",
        colorPreview: "Kleurvoorbeeld",
        colorant: "Kleurpasta",
        colorantBatchNumber: "Colorant batchnummer",
        colorantPackage: "Pigment verpakking",
        colorants: "Kleurpasta's",
        colors: "Colors",
        company: "Bedrijf",
        competitiveColor: "Competitive color",
        confirm: "Bevestigen",
        confirmDeletion: "Wilt u dit item echt permanent verwijderen?",
        confirmHelpSettings: "Wilt u het formulier opslaan en de velden leeg laten?",
        connect: "Verbinden",
        continue: "Verdergaan",
        correction: "Correction",
        country: "Land",
        created: "Gemaakt",
        creationDateOf: "Aanmaakdatum van",
        criticalLevel: "Kritisch niveau",
        currency: "Valuta",
        currentBatchNumber: "Huidig batchnummer",
        currentUfiCode: "Huidig UFI code",
        custom: "Aangepast",
        customData: "Custom data",
        customFandeck: "Kleurenwaaier op maat",
        customFormula: "Aangepaste formule",
        customPackage: "Aangepast",
        customPackageSettings: 'Aangepaste verpakking instellingen"',
        customer: "Klant",
        customerVersion: "Klantversie",
        customers: "Klanten",
        database: "Database",
        date: "Datum",
        default: "Standaard",
        delete: "Verwijderen",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Beschrijving",
        disconnect: "Loskoppelen",
        discount: "Korting",
        discover: "Ontdekken",
        dispense: "Doseren",
        dispensing: "Doseren",
        doNotShowAgain: "Dit bericht niet meer weergeven",
        downloadingFile: "Bestanden dowloaden",
        edit: "Bewerken",
        email: "E-mail",
        enabled: "Ingeschakeld",
        error: "Fout",
        expandAll: "Alles uitvouwen",
        exportData: "Exporteer gegevens",
        exportPdf: "Exporteer PDF",
        fan: "Kleurwaaier",
        fandeck: "Kleurenwaaier",
        fandeckCode: "Fandeck code",
        fandeckName: "Naam kleurenwaaier",
        fandecks: "Kleurenwaaiers",
        favorite: "Favoriet",
        fileTransfer: "Bestandsoverdracht",
        filling: "Aanvullen",
        fillingDate: "Vuldatum",
        find: "Zoek",
        finish: "Klaar",
        finishedCorrection: "Finished correction",
        formula: "Formule",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "QR-code scannen",
        gravimetric: "Gravimetrisch",
        historical: "Historical",
        history: "Geschiedenis",
        hours: "Uren",
        id: "ID",
        images: "Afbeeldingen",
        in: 'in"',
        index: "Index",
        insertBarcode: "Voer een streepjescode in",
        install: "Installeer",
        installed: "GeÃ¯nstalleerd",
        instructions: "Instructies",
        internalNote: "Interne notitie",
        interval: "Interval",
        ip: "IP-adres",
        itemNumber: "Item nr.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limiet",
        load: "Laden",
        loadFormula: "Laden van formule",
        localVersion: "Lokaal Versie",
        machine: "Machine",
        manualCorrection: "Manual correction",
        manually: "Handmatig",
        margin: "Marge",
        markup: "Marge",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Maximaal niveau",
        maxValue: "Maximum waarde",
        maximum: "Maximum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamerie",
        minimum: "Minimum",
        minutes: "Min.",
        missingItem: "Ontbrekend onderdeel",
        missingRequiredItems: "Alle vereiste items (gemarkeerd met een asterisk) moeten worden ingevuld",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Meer",
        moreInfo: "Meer informatie",
        moveDown: "Naar beneden",
        moveUp: "Naar boven",
        myOrders: "Mijn orders",
        name: "Naam",
        nameTitle: "Naam",
        new: "Nieuw",
        next: "Volgende",
        no: "Nee",
        noColorantsAvailable: "Geen colorants beschikbaar",
        noFormulas: "Nog geen formules",
        noPricesAvailable: "Geen prijs beschikbaar",
        nominalAmount: "Nominaal aantal",
        notAvailable: "Niet beschikbaar",
        note: "Opmerking",
        numberOfCanisters: "Aantal canisters",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Aantal labels",
        numberOfPackages: "Aantal verpakkingen",
        off: "Uit",
        ok: "Oke",
        on: "Aan",
        onFocus: "On focus",
        open: "Open",
        operator: "Operator",
        options: "Opties",
        order: "Order",
        other: "Ander",
        otherError: "Andere storing",
        out: "Uit",
        overwrite: "Overwrite",
        package: "Verpakking",
        packagePreview: "Voorbeeld verpakking",
        partialUpdates: "Partial updates",
        phone: "Telefoonnummer",
        pleaseWait: "Wacht alsjeblieft",
        previous: "Vorige",
        price: "Prijs",
        priceGroup: "Prijsgroep",
        print: "Afdrukken",
        printTask: "Print opdracht",
        processingStep: "Processing %{step}",
        product: "Product",
        productCode: "Productcode",
        productName: "Product naam",
        products: "Producten",
        pump1: "Pomp 1",
        pump2: "Pomp 2",
        purchasePrice: "Aankoopprijs",
        purge: "Nozzles doorspoelen",
        qualityControl: "Quality control",
        quantity: "Hoeveelheid",
        quantityQty: "QTY",
        quickTint: "Handmatig doseren",
        rccIsNotAvailable: "RCC is niet beschikbaar",
        rccIsNotConnected: "RCC is niet verbonden",
        rccNotLicensed: "RCC heeft geen licentie",
        reconnect: "Opnieuw verbinden",
        refill: "Hervullen",
        refillManualLevelCorrection: "Handmatige aanpassing",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Resetten",
        restart: "Herstart",
        restore: "Herstellen",
        retint: "Opnieuw tinten",
        revision: "Revisie",
        safetySheet: "SDS",
        save: "Opslaan",
        saveAs: "Opslaan als",
        saveToDispensingHistory: "Opslaan in geschiedenis",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Alles selecteren",
        selectChannels: "Selecteer circuit",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Verkoopprijs",
        settings: "Instellingen",
        shelf: "Bliktafel",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Maat",
        skip: "Overslaan",
        smartPurge: "Slim purgeren",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spectrofotometer",
        standardFormula: "Standaard formulering",
        status: "Status",
        street: "Straat",
        sum: "Som",
        summary: "Overzicht",
        sync: "Synchroniseren",
        technicalSheet: "Technisch informatieblad",
        templates: "Sjabloon",
        threshold: "Drempelwaarde",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Te doseren orders",
        top: "Bovenaan",
        total: "Totaal",
        totalAmount: "Totale hoeveelheid",
        totalBaseAmount: "Totaal basis",
        totalColorantAmount: "Totaal colorant",
        type: "Type",
        ufiCode: "UFI-code",
        ufiThreshold: "UFI drempelwaarde",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "Eenheden",
        unknown: "Unknown",
        update: "Update",
        updated: "Bijgewerkt",
        user: "Gebruiker",
        value: "Waarde",
        vat: "BTW",
        verified: "Verified",
        version: "Versie",
        versionId: "ID versie",
        versionStructure: "Structuur versie",
        volumetric: "Volumetrisch",
        warning: "Waarschuwing",
        warningLevel: "Waarschuwingsniveau",
        withoutName: "Zonder naam",
        workingProperly: "Working properly",
        yes: "Ja",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: 'Als deze instelling is ingeschakeld, worden bijgevulde colorant batches bijgehouden."'
        },
        connection: {
            add: "Maakt het mogelijk om handmatig een nieuwe server toe te voegen als deze niet kon worden gedetecteerd via de Discover-functie.",
            clientIdentifier:
                "Met deze instelling kan deze client worden geÃ¯dentificeerd als er meer clients zijn verbonden met Ã©Ã©n server.",
            disconnect:
                "Informatie over de momenteel gebruikte server. Met de loskoppelingsknop kunt u deze server verlaten en, indien beschikbaar, overschakelen naar een andere.",
            discover: "Ontdekt of er andere servers beschikbaar zijn in het netwerk.",
            dropServers: "Verwijdert alle eerder gedetecteerde servers uit de lijst.",
            dropServersNotAvailable: "Geen server beschikbaar.",
            edit: "Maakt het mogelijk om een reeds gevonden server handmatig te bewerken.",
            editDisabled: "Geen server beschikbaar. "
        },
        continue: "Wilt u doorgaan?",
        driverSettings: {
            alfaRestApi: {
                host: "Voer de hostnaam of het IP-adres van de computer in.",
                machineType: "Geldig voor alle Alfa-machines. Zowel Windows als Linux."
            },
            corobDsProxy: {
                machineType:
                    "Geldig voor generaties Slave (D200, D600 ..), 4G (First One) en 5G (EvoFlx). DspProxy moet zijn geÃ¯nstalleerd. Alleen Windows."
            },
            corobEvoDriver: {
                machineType:
                    "Geldig voor generatie 5G (EvoFlx). EVOservice moet geÃ¯nstalleerd zijn. Zowel Windows als Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "SSelecteer het dispenserconfiguratiebestand. Standaard preset.",
                hldRootDir: "Selecteer de hoofdmap van HLD. Standaard preset.",
                machineType:
                    "Geldig voor Corob Flex (500, 520, 540) = voormalige Lenteq. HLD moet zijn geÃ¯nstalleerd. Alleen Windows."
            },
            corobNextDriver: {
                machineType:
                    "Geldig voor generaties Slave (D200, D600 ..), 4G (First One) en 5G (EvoFlx). NextDriver moet zijn geÃ¯nstalleerd. Alleen Linux."
            },
            dromontDDrv: {
                databasePath: "Pad naar het databasebestand met kalibratiegegevens. Standaard preset.",
                driverPath: "Pad naar de driver (D_DRV.exe). Standaard preset.",
                machineType:
                    "Indirecte dispensercommunicatie via vaste paden. Geldig voor generaties V1 en V2. D_SET moet zijn geÃ¯nstalleerd. Zowel Windows als Linux.",
                resultPath:
                    "Pad naar het resultaatbestand dat is gemaakt nadat de bewerking is voltooid. Standaard preset.",
                serviceSoftwarePath: "Pad naar de Dromont-servicesoftware (D_SET.exe). Defalut vooraf ingesteld."
            },
            dromontDirect: {
                machineType:
                    "Directe dispensercommunicatie. Geldig voor generaties V1 en V2. D_SET moet zijn geÃ¯nstalleerd. Zowel Windows als Linux.",
                rootDir: "Selecteer de hoofdmap van Dromont. Standaard preset."
            },
            dromontMisura: {
                driverPath:
                    "Het pad naar de driver (MisuraRetail.exe) kan veranderen op basis van de Misura Retail-versie. Standaard preset.",
                extensionPath: "Pad naar communicatiebestand voor serviceacties.",
                formulaPath: "Pad naar communicatiebestand voor doseren.",
                machineType: "Geldig voor generatie V3. Dromont Misura moet worden geÃ¯nstalleerd. Alleen Windows."
            },
            fastAndFluidIDD: {
                machineType: "Geldig voor alle F & F-machines. Alleen Windows.",
                path: "Ondersteund zijn IDD2 (HA 450, HA 650, X-smart, etc.) - moet gelicentieerd zijn, IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Geldig voor alle F & F-machines. Zowel Windows als Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Geldig voor alle Hero-machines. Alleen Windows."
            },
            italtinto: {
                machineType:
                    "Geldig voor alle Italtinto-machines. Wcal of ItaltintoCal moet zijn geÃ¯nstalleerd. Alleen Windows.",
                path: "Pad naar het aangepaste configuratiebestand van Italtinto."
            },
            manualAdvanced: {
                machineType:
                    "Geldig voor alle handmatige machines, inclusief houderondersteuning. Zowel Windows als Linux.",
                path: "Pad naar het configuratiebestand met gegevens over de dispenser en canisters."
            },
            manualSimple: {
                machineType: "Geldig voor alle handmatige machines. Zowel Windows als Linux.",
                path: "Pad naar het configuratiebestand met gegevens over de dispenser."
            },
            none: {
                machineType: "Er is geen dispenserdriver geselecteerd."
            },
            santintColorLink3: {
                machineType: "Geldig voor alle Santint-machines. Alleen Windows."
            },
            simulation: {
                machineType:
                    "Geldig voor simulatiedispenser als er geen echte dispenser op de computer is aangesloten.",
                path: "Pad naar het simulatieconfiguratiebestand dat in overeenstemming moet zijn met de ingevoegde database."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "Het overzicht van aanvullende software-plug-ins.",
            allowAutoCloseTab:
                "Als de instelling is ingeschakeld, wordt elk formuletabblad automatisch gesloten nadat het uitgifteproces is voltooid.",
            allowAutomaticClientStart:
                "Als deze instelling is ingeschakeld, wordt %{name} automatisch gestart na het opstarten van de computer.",
            allowAutomaticPrint: "Labels worden automatisch geprint. Verdere instelling vereist voor en of na doseren.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "In het deelvenster Formule is het gedeelte Klanten toegankelijk.",
            allowDispensing: "Doseer knop zal worden geactiveerd op formule deelvenster.",
            allowFileTransfer:
                "Als deze instelling is ingeschakeld, is de automatische gegevensimport en -export via bestandsoverdracht beschikbaar.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} zal toegankelijk zijn",
            allowOrdering: "Bestelknop zal worden geactiveerd op formule deelvenster",
            allowPricing:
                "Op het Formulepaneel kunnen de prijzen worden gebruikt. Zichtbaarheid van prijzen is vastgelegd in Beschikbare prijzen. De prijzen zijn vastgelegd in Prijsinstellingen.",
            allowProductPreviewImage: "Product afbeelding zal getoond worden bij doseren",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification:
                "Order notificatie zal gebeuren door geluid in melody af te spelen eens order geplaatst is.",
            allowSpectro: "Spectro sectie zal beschikbaar zijn",
            allowTabs:
                "Als deze instelling is ingeschakeld, is het mogelijk om met meerdere tabbladen tegelijk te werken.",
            applyZoom:
                "Zoom vergroot of verkleint resolutie. Toetsenbord shortcuts CTRL+ en CTRL - zijn beiden toepasbaar",
            automaticLogout: "Stel in na hoeveel minuten er automatisch wordt uitgelogd.",
            availableDatabases:
                "De instellingen maken het mogelijk om te wisselen tussen databases als er meerdere beschikbaar zijn.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "De barcode-testomgeving dient om de juistheid van de gescande barcode te controleren door deze te vergelijken met de barcodes die in de database zijn ingevoegd.",
            customBanner: "Stel uw eigen logo of banner en de positie ervan in.",
            customCurrencyFormat:
                "Aangepaste valuta-indeling kan de standaard valuta-indeling op basis van de geselecteerde taal overschrijven.",
            customDateFormat:
                "Aangepaste datumnotatie kan de standaard datumnotatie overschrijven op basis van de geselecteerde taal.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "De geselecteerde printer zal gebruikt worden tenzij dit wordt aangepast in het printer opties scherm",
            defaultTemplate:
                "Het geselecteerde sjabloon zal gebruikt worden bij het printen van labels tenzij aangepast in het printer opties scherm",
            deleteImportedData:
                "Verwijdert de eerder geÃ¯mporteerde aangepaste gegevens. De gegevens kunnen na verwijdering opnieuw worden geÃ¯mporteerd.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "Op het Formulepaneel is het gedeelte met de doseer notities toegankelijk.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "In %{name} is een virtueel toetsenbord beschikbaar.",
            exportLocalSettings: "Exporteert de lokale instellingen van deze computer.",
            exportStaticSql:
                "Exporteert de lokale instellingen van deze computer. Het geÃ«xporteerde bestand kan worden gebruikt om met deze setup een database te maken.",
            exportTranslationKeys:
                "Exporteer de nieuwste vertalingen en stuur ze na vertaling per e-mail naar uw softwareleverancier om ze te laten importeren.",
            favoriteButton: "Klik om de formule als favoriet toe te voegen",
            formulaNotes: "In het deelvenster Formule is het gedeelte met formules beschikbaar.",
            helpSettings: "Informatie is beschikbaar in de help sectie in het snelle toegangspaneel",
            importCustomData: "Importeert de lokale aangepaste gegevens op basis van het geselecteerde formaat.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importeert de lokale instellingen van deze computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "De instellingen zorgen ervoor dat de omgeving van %{name} niet kan worden verlaten - het maakt de ultieme kioskstandervaring mogelijk. Alleen van toepassing op Windows.",
            maxNumberTabs: "Tab limiet stelt in hoeveel formule tabbladen tegelijk kunnen geopend worden",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "De instelling vereist informatie over hoeveel etiketkopieÃ«n moeten worden afgedrukt na het doseren.",
            printAsImage:
                "Afdrukken als afbeelding helpt bij het oplossen van de problemen wanneer de standaardafdrukmethode mislukt. Gebruik het niet wanneer standaard afdrukken correct werkt. Alleen compatibel met Linux.",
            printBeforeDispensing:
                "De instelling vereist informatie over hoeveel etiketkopieÃ«n moeten worden afgedrukt voor het doseren.",
            printEnabled:
                "Met deze instelling kan de printer met de software worden gebruikt. Aanvullende instellingen zijn in Afdrukinstellingen.",
            printOnRequest: "Op het paneel Formule wordt de knop Afdrukken geactiveerd.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate:
                "De geselecteerde sjabloon wordt gebruikt bij het afdrukken van labels bij snelle dosering.",
            restoreLocalSettings: "Herstelt de lokale instellingen van deze computer.",
            runLightAtStartUp: "%{light} wordt gestart in plaats van %{name}.",
            screenSaverTimeout: "Stel in na hoeveel minuten de screensaver moet worden geactiveerd.",
            selectCustomDataFormat:
                "Selecteer het formaat van de originele gegevens die moeten worden geÃ¯mporteerd. Voor elk formaat zijn mogelijk andere aanvullende bestanden en instellingen vereist.",
            setCustomHomeButton: "Thuis-knop in %{name} zal doorverwijzen naar het geselecteerde venster.",
            setFts: "Volledige tekst zoekfunctie  staat volledige tekst zoekopdracht toe",
            setKeyboardShortcuts:
                "Het is niet mogelijk om dezelfde sneltoets in te stellen voor twee verschillende acties.",
            setNumberOfDecimalPlaces:
                "Afronding stelt in hoeveel decimalen bij pigmenten in de formule worden gebruikt.",
            setOrderSearchParameters:
                "Order zoeken bepaalt welke parameters worden gebruikt bij het zoeken tussen orders. Alleen toegankelijk in %{name}.",
            setOverwriteLastTab:
                "Wanneer u een nieuwe formule kiest via globaal zoeken terwijl de limiet van het formuletabblad is bereikt, wordt het laatst geladen formuletabblad overschreven door de nieuwe formuleselectie.",
            setSearchPanel:
                "Stel uw eigen zichtbaarheid en volgorde in van items die worden gebruikt bij het zoeken naar een nieuwe formule.",
            setVisibilityAndOrder:
                "De geselecteerde navigatie-items zullen zichtbaar zijn in het snelle toegangspaneel. De hoogste positie hier definieert de meest linkse positie in het paneel. Het maximaal toegestane aantal navigatie-items is 6.",
            setYourLanguage: "Taalverandering vereist opnieuw opstarten van de software.",
            settingsSearch: "Zoek verschillende instellingen op als u niet zeker weet waar u ze kunt vinden.",
            showNewOrderNotifications:
                "Bestellingsmelding is een pop-upvenster waarin wordt aangekondigd dat een nieuwe bestelling is ontvangen.",
            sorting:
                "Snelle tint kan ervoor zorgen dat de canisters geordend worden volgens de namen van de pigmenten of op verpakking-ID's.",
            turnOnKioskMode: "Kioskmodus op taakbalk verbergen.",
            windowClosingRules:
                "De instelling bepaalt of het venster Quick tint sluit voor of na het begin van het doseerproces."
        },
        formulaSettings: {
            additionalFormulaTab:
                "De instelling bepaalt welk paneel wordt weergegeven bij het openen van een nieuw formuletabblad.",
            allowCustomFormulas: "Het maken en zoeken naar aangepaste formules wordt geactiveerd.",
            allowCustomPackageSize:
                "In het deelvenster Formule wordt de optie Aangepaste verpakkingsgrootte geactiveerd.",
            allowEditingColorants:
                "Op het deelvenster Formule wordt de knop pigment bewerken geactiveerd (zichtbaar na het selecteren van een kleur).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "In het deelvenster Formule is het kleurenvoorbeeld de enige zichtbare informatie.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Het inschakelen van deze instelling resulteert in pop-ups om het verwijderen van een item te bevestigen.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "Bij het starten van %{name} verschijnt het deelvenster Favorieten.",
            formulaAutomaticNaming:
                "Een gewijzigde formule krijgt automatisch een naam op basis van de uitgevoerde kleurstofaanpassingen.",
            formulaPanel: "Bij het openen van een nieuw tabblad, verschijnt het deelvenster Formule",
            formulaPanelInitial: "Bij het starten van %{name} verschijnt het formule deelvenster.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "Op het deelvenster Formule is de productafbeelding zichtbaar naast het kleurvoorbeeld met de mogelijkheid om het deelvenster met meer info te openen.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "De instelling bepaalt welk paneel wordt weergegeven nadat %{0} is gestart.",
            moreInfo:
                "In het deelvenster Formule is het informatie deelvenster zichtbaar naast het kleurvoorbeeld en het productbeeldvoorbeeld.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "De instelling maakt het mogelijk om productcodes te gebruiken samen met productnamen, indien beschikbaar in de database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "Wanneer u een nieuw tabblad opent, verschijnt Nieuwe formule zoeken (bevat informatie over de laatst verstrekte formules en favoriete formules).",
            searchNewFormulaInitial:
                "Bij het starten van %{name} verschijnt Nieuwe formule zoeken (bevat informatie over de laatst verstrekte formules en favoriete formules).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "Als deze instelling is ingeschakeld, is de functie van concurrerende kleuren zoeken in Kleurenpalet beschikbaar",
            setFormulaInfoInPreview:
                "In het formulepaneel is het geselecteerde gegevenstype altijd zichtbaar in het kleurenvoorbeeld.",
            setFormulaPreview:
                "De instelling verandert de positie en weergave van kleurvoorbeeld, pakketafbeelding en informatiegegevens over de kleur.",
            setFormulaRGBPreviewVisibleInformation:
                "In het deelvenster Formule is het geselecteerde gegevenstype altijd zichtbaar in kleurvoorbeeld.",
            setFormulaUnit:
                "In het deelvenster Formule bepaalt deze instelling welke kleureenheid als eerste wordt geopend na het selecteren van een kleur. Ook van toepassing in Quick Tint.",
            setFormulaVisibilityAndOrder:
                "In het deelvenster Formule zijn de geselecteerde gegevens zichtbaar in de sectie Meer info (alleen van toepassing als Voorbeeldformule instellen in Formule-instelling Afbeelding of Meer info is.",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "In het deelvenster Formule bepaalt deze instelling welke pigment eenheden zichtbaar zijn na het selecteren van een kleur. Ook van toepassing in Quick Tint.",
            showColorPreview:
                "In het deelvenster Formule, wordt een klein kleurvoorbeeld naast de kleurnaam getoond bij het zoeken naar een nieuwe formule.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overvulling is gedetecteerd.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Ik ken de risico's, ga door"
        },
        help: "Help",
        helpLink: "Helpcentrum",
        helper: {
            automaticallyCheckForUpdates:
                "Er wordt automatisch gecontroleerd of er binnen het gegeven tijdsinterval een update beschikbaar is voor %{name} of database.",
            automaticallyDownloadUpdates:
                "Als er een update beschikbaar is, wordt deze automatisch gedownload zonder te hoeven bevestigen.",
            automaticallyInstallNewDatabases:
                "Als een tot nu toe afwezige database wordt verzonden, wordt deze geÃ¯nstalleerd als een nieuwe database. Daarna kan de DB worden gebruikt.",
            automaticallyInstallUpdates:
                "Als een update is gedownload, wordt deze automatisch geÃ¯nstalleerd zonder te hoeven bevestigen.",
            canBrowseChangeLog:
                "Bij het updaten van de software is de officiÃ«le %{name} changelog beschikbaar om te zien",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "De update wordt 's nachts geÃ¯nstalleerd als de computer actief is."
        },
        licensing: {
            collect:
                "De logfiles worden gedownload naar de geselecteerde locatie. De logfiles zijn vereist door de meegeleverde software voor buganalyse.",
            company: "Het bedrijf dat de licentie heeft geleverd.",
            computerID: "Licentie-identificatie om de softwareleverancier te helpen in geval van vereiste assistentie.",
            email: "Het e-mailadres van de vergunninghouder.",
            licenseUuid:
                "Licentie-identificatie om de softwareleverancier te helpen in geval van vereiste assistentie.",
            name: "De naam van de vergunninghouder.",
            openBugreport:
                "Laat het ons weten als er een bug in de software zit en stuur ons een rapport met de bugbeschrijving.",
            posInfoContactperson: "POS-informatie over de eigenaar die op het etiket moet worden afgedrukt.",
            posInfoMachineInformation:
                "POS-informatie over de dispenser die op het etiket moet worden afgedrukt of in het netwerk moet worden herkend.",
            posInfoPos: "POS-informatie over de locatie die op het label moet worden afgedrukt.",
            reactivation: "Heractivering of wijziging van de huidige licentie.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registratie-informatie om de eigenaar van de licentie te identificeren.",
            registrationMachineInformation: "Registratie-informatie om de uitgever van de licentie te identificeren.",
            registrationPos: "Registratie-informatie om de locatie van de licentie te identificeren.",
            versionScope: "De limieten voor het vervallen van de software.",
            versionType: "Het softwareproducttype."
        },
        machineIsBusy: "Fouten kunnen niet gereset worden aangezien de machine nog bezig is",
        machineSettings: {
            allowManualColorantAddition:
                "Indien de nodige hoeveelheid pigment de maximale toegestane hoeveelheid overschrijdt, kunt u deze handmatig toevoegen na het doseren",
            autotasks:
                "Autotaken zijn automatische machine- en computeronderhoudstaken die kunnen worden ingesteld om op een bepaald tijdstip of tijdsinterval te worden uitgevoerd.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "De barcode wordt toegewezen aan de canister waarin de kleurstof verkrijgbaar is. De streepjescode is nodig om het correct bijvullen van kleurstof te garanderen.",
            checkCanBeforeDispense: "De instelling is alleen geldig voor Fast & Fluid-simulatie.",
            checkOverfill:
                "De instelling controleert of er voldoende plaats in het blik is voor de pigmenten alvorens te doseren.",
            currentlySelectedMachine: "Geeft informatie over de momenteel geselecteerde machine.",
            dispenseInvalidColorants:
                "Met deze instelling kunnen kleurstoffen worden afgegeven die niet zijn gedefinieerd in de machineconfiguratie door handmatige toevoeging van kleurstoffen te vragen.",
            dispenserConfigurationBackup:
                "Download en sla de huidige machineconfiguratie op om een back-up te behouden.",
            dispensingLogic:
                "Doseer Logic-types kunnen een ander gedrag voor elke canisters garanderen wanneer er meer kleurstof moet worden afgegeven dan toegestaan of gewenst. Bijkomend gedrag wordt ingesteld in Afgifte-instellingen.",
            enableTmc: "Met deze instelling kunnen gegevens naar TMC worden verzonden.",
            enableUserIdentification: "De gebruiker moet inloggen voordat dosering is toegestaan.",
            machineUnit: "Machine-eenheid definieert de maateenheid voor pigmenten in de canisters.",
            minDispensedAmount:
                "Minimum doseer aantal bepaalt hoeveel pigment moet gedoseerd worden om het purgeren te voltooien (om extra purgeren te vermijden)",
            minimalDispenseAmount:
                "Minimale dosering is de kleinste aanbevolen hoeveelheid pigment die kan worden gedoseerd. Als deze wordt overschreden, verschijnt een bericht (doseren is nog steeds mogelijk).",
            missingAutotaskCanisters: "Er moet minimaal 1 canister worden geselecteerd",
            missingAutotaskChannels: "Er moet minimaal 1 kanaal zijn geselecteer",
            missingAutotaskChannelsValue: "Het volume van alle geselecteerde kanalen moet worden ingevuld",
            missingAutotaskCleanTime: "De reinigingstijd moet worden ingevuld",
            missingAutotaskName: "De naam van de autotask moet worden ingevuld",
            missingAutotaskRecirculation: "Tijd en snelheid van recirculatie moeten worden ingevuld",
            missingAutotaskStirring: "Tijd en snelheid van roeren moet worden ingevuld",
            missingAutotaskVolume: "Het purgeervolume moet worden ingevuld",
            placeCanSensor:
                "De instelling activeert de sensor voor de plaatsing van het blik - de dosering start niet tenzij de bus correct is geplaatst.",
            placeCanSensorDelay:
                "Aanbevolen instelling gekoppeld aan plaats blik sensor. Het zorgt ervoor dat de dosering pas begint na de gedefinieerde tijdsperiode waarin het blik correct is geplaatst.",
            purgeVolume: "Het purgeervolume bepaalt hoeveel pigment wordt gepurgeerd tijdens het smart purgeren.",
            rccUrl: "Redlike Control Center (RCC) is verantwoordelijk voor de communicatie met de dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "De instelling activeert de sensor voor het verwijderen van het blik - het doseren wordt niet als voltooid beschouwd tenzij het blikje is verwijderd.",
            removeCanSensorDelay:
                "Aanbevolen instelling gekoppeld om can-sensor te verwijderen. Het zorgt ervoor dat de afgifte pas is voltooid na de gedefinieerde tijdsperiode waarin het blik is verwijderd.",
            skipPlaceCanDialog:
                "Als deze instelling is ingeschakeld, wacht de dispenser niet bij het plaatsen van een blik totdat op de OK-knop wordt gedrukt, maar start het dispenser-proces automatisch.",
            skipRemoveCanDialog:
                "Als deze instelling is ingeschakeld, wacht de dispenser niet bij het verwijderen van een blik totdat op de OK-knop wordt gedrukt, maar zal het doseerproces automatisch worden voltooid.",
            smartPurgeType:
                "Het purgertype kan overwegen om alleen te doseren of om te doseren plus andere purgeergebeurtenissen bij het valideren of smart purge nodig is.",
            splitFormula:
                "Als de vereiste hoeveelheid pigment de maximale hoeveelheid dosering overschrijdt, kunt u met de instelling een deel pigment doseren, de canister opnieuw vullen en vervolgens de rest blijven doseren.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Basis blik moet worden gevalideerd via barcode voordat doseren is toegestaan. De instelling zorgt ervoor dat de juiste basis wordt gebruikt.",
            validateColorantsDuringInit:
                "De machineconfiguratie wordt elke keer dat RCC opnieuw wordt opgestart, vergeleken met de database. Bij mismatches vindt er een melding plaats."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes: "Opent venster met canister barcode overzicht met mogelijkheid tot instellen",
            canisterLevel: "Opent venster met canister niveau overzicht met mogelijkheid tot instellen",
            canisters: "Opent venster met canister niveau overzicht met mogelijkheid tot instellen",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel:
                "Opent venster met mogelijkheid tot zoeken van een nieuwe formule in een digitale kleurenwaaier",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Opent een venster met het overzicht van uitgevoerde vullingen voor canisters.",
            customFormula: "Opent venster met mogelijkheid tot het maken van een nieuwe formule",
            customers: "Opent venster met overzicht van de klanten en de mogelijkheid tot wijzigen",
            dispensingHistory: "Opent venster met overzicht van gedane doseringen",
            favorites: "Opent een paneel met de mogelijkheid om eenfavoriete formule te selecteren.",
            help: "Opent venster met klant service informatie indien beschikbaar",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "Geldig voor %{name} exclusief, opent venster met overzicht van gedoseerde orders",
            machineReset: "Start dispenser reset",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Bestellingen die vanaf deze computer zijn verzonden",
            purge: "Opent venster met mogelijkheid tot purgeren canister",
            quickTint: "Opent venster met mogelijkheid tot manuele dosering",
            searchFormula: "Opent venster met mogelijkheid tot zoeken van een nieuwe formule",
            spectro: "Opent venster met mogelijkheid tot meten met spectrometer",
            stir: "Opent venster met mogelijkheid tot roeren van canister",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Bestellingen die door deze computer zijn ontvangen"
        },
        noHelpForLicense: "Er is geen help functie beschikbaar voor uw licensie, vraag erom bij uw leverancier",
        posInfo: {
            sync: "Synchroniseert gegevens met de sectie Registratie"
        },
        poweredByDeso: "Aangedreven door %{name}",
        priceSettings: {
            VatPrice: "Pigment BTW waarde in %",
            VatPriceProduct: "De btw van het generieke product is voor elke kleurstof hetzelfde. Ingesteld in %.",
            basePurchase: "Aankoopprijs voor basis",
            basePurchasePriceProduct: "Aankoopprijs voor het pakket van de opgegeven basis. In geselecteerde valuta.",
            baseSell: "Verkoopprijs voor enkel basis ( incl. basis en marge )",
            baseSellFull: "Sell full price for base.",
            cntName: "Bepaalt aan welke kleurstof de prijs gerelateerd is.",
            cntPurchase: "Aankoopprijs voor pigmenten",
            cntPurchaseByName: "Aankoopprijs voor pigmenten individueel berekend per stuk ",
            cntPurchasePricePerLiter: "Kostprijs pigment per liter ( zonder marge )",
            cntSell: "Verkoopprijs voor enkel pigmenten ( incl. pigment en marge)",
            cntSellByName:
                "Verkoopprijs voor alle pigmenten gebruikt bij het product, individueel berekend voor elk pigment (incl pigment en marge)",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Kleurstof BTW-waarde ingesteld in %.",
            colorants:
                "De generieke pigment prijzen zijn voor elk pigment hetzelfde. Deze functie is vooral handig voor het instellen van de btw.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "De generieke kleurstofprijzen zullen voor elke kleurstof hetzelfde zijn. Verkoopprijs wordt aanbevolen door te wijzigen met korting. In geselecteerde valuta.",
            currencyCodeNew: "Valutacode moet de officiÃ«le vorm hebben, bijvoorbeeld EUR.",
            currencyNameNew: "De naam van de valuta, bijvoorbeeld Euro.",
            currencyRateNew:
                "De valutakoers ten opzichte van de hoofdvaluta, bijvoorbeeld 25,855 CZK voor 1 â¬. De koers moet continu worden aangepast om up-to-date te blijven.",
            currencyRoundingNew:
                "Afronding stelt de kleinst mogelijke betaalbare waarde van de valuta in, bijvoorbeeld Euro heeft afronding 0,01 omdat de kleinst mogelijke waarde 1 cent is.",
            currencySymbolNew: "Het officiÃ«le symbool van de valuta, bijvoorbeeld â¬ voor Euro.",
            defaultPrice: "Prijs voor pigment ingesteld in de geselecteerde database (zonder BTW).",
            defaultPriceGroup: "Pigmentprijs voor prijsgroep ingesteld in de geselecteerde database (zonder BTW).",
            defaultVatPrice: "BTW-kleurstof ingesteld in de geselecteerde database.",
            discountHeader:
                "Korting trekt de gedefinieerde waarde af van de aankoopprijs van kleurstof. Ingesteld in %.",
            discountHeaderProduct:
                "Korting trekt de gedefinieerde waarde af van de prijs van de productkleurstof. Ingesteld in %.",
            export: "Exporteer een bestand met de momenteel ingevoegde prijzen. Na het aanpassen van de prijzen kan het weer geÃ¯mporteerd worden.",
            import: "Importeer een correct opgemaakt (geÃ«xporteerd) bestand om de prijzen in te voegen of te wijzigen.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Kies welke prijsberekening moet worden gebruikt voor het bepalen van de uiteindelijk beschikbare prijs. Marge en markup worden opgeteld, terwijl korting wordt afgetrokken van de gegeven verkoopprijs.",
            marginAll: "De prijs voor marge / markup voor meerdere pakketten (incl. Marge / markup).",
            marginHeader:
                "Marge voegt de gedefinieerde waarde toe aan de aankoopprijs van de kleurstof. Ingesteld in %.",
            marginHeaderProduct:
                "Marge voegt de gedefinieerde waarde toe aan de aankoopprijs van het product. Ingesteld in %.",
            marginPerPkg: "De prijs voor marge / markup voor Ã©Ã©n pakket (incl. Marge / markup).",
            markupHeader: "Markup voegt de gedefinieerde waarde toe aan de aankoopprijs van kleurstof. Ingesteld in %.",
            markupHeaderProduct:
                "Markup voegt de gedefinieerde waarde toe aan de aankoopprijs van het product. Ingesteld in %.",
            packagePricing: "Extra toeslag individueel ingesteld voor elke verpakking.",
            packageSurcharge: "De generieke verpakkingsprijzen zijn hetzelfde voor elke toeslag per pakket.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "De pigment prijs die wordt gebruikt bij het berekenen van de prijsgroepsprijs.",
            priceGroups:
                "Prijsgroepen geeft het nummer van de relevante prijsgroep weer (de grenzen worden ingesteld in de database of in generieke prijzen).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Prijsgroepen zijn prijsintervallen van de uiteindelijke verf op basis van pigment prijzen in de formule.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "BTW-waarde op productbasis voor het opgegeven pakket, ingesteld in %.",
            productName: "Bepaalt op welke productbasis de prijs betrekking heeft.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing:
                "Aankoopprijs voor alle pakketten wordt gebruikt bij het distribueren van aangepaste verpakkingen.",
            productSize: "Bepaalt op welk pakket van de gegeven productbasis de prijs betrekking heeft.",
            productVat: "Productbasis BTW-waarde ingesteld in %.",
            products:
                "De generieke productprijzen zijn voor elk product hetzelfde. Deze functie is vooral handig voor het instellen van de BTW.",
            productsSellPrice:
                "De generieke productprijzen zullen voor elke kleurstof hetzelfde zijn. Verkoopprijs wordt aanbevolen door te wijzigen met korting. In geselecteerde valuta.",
            sellPriceAll:
                "De verkoopprijs van meerdere verpakkingen (incl. Basis, kleurstoffen, toeslag en marge / opmaak).",
            sellPricePerKg:
                "De verkoopprijs van het product per kilogram (incl. Basis, kleurstoffen, toeslag en marge / opmaak).",
            sellPricePerL:
                "De verkoopprijs van het product per liter (incl. Basis, kleurstoffen, toeslag en marge / opmaak).",
            sellPricePerPkg:
                "De verkoopprijs van Ã©Ã©n verpakking (incl. Basis, kleurstoffen, toeslag en marge / opmaak).",
            setPriceTypesVisibilityAndOrder:
                "In het deelvenster Formule zijn de geselecteerde prijzen zichtbaar in het gedeelte met prijzen. De hoogste positie hier definieert de meest linkse positie in de sectie.",
            surchargeAll: "De prijs van een extra vergoeding voor meerdere verpakkingen (incl. Toeslag).",
            surchargePerPkg: "De prijs van een extra vergoeding voor Ã©Ã©n verpakking (incl. Toeslag).",
            tintPurchaseAll:
                "De aankoopprijs voor het hele kleurproces van meerdere pakketten (incl. pigment en toeslag).",
            tintPurchasePerPkg:
                "De aankoopprijs voor het hele kleurproces van Ã©Ã©n verpakking (incl. pigment en toeslag).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "De totale aankoopprijs van het product voor meerdere verpakkingen (incl. Basis en pigmenten).",
            totalPurchasePerKg: "De totale aankoopprijs van het product per kilogram (incl. Basis en pigment).",
            totalPurchasePerL: "De totale aankoopprijs van het product per liter (incl. Basis en pigment).",
            totalPurchasePerPkg: "De totale aankoopprijs van het product voor Ã©Ã©n verpakking (incl. Basis en pigment).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "Op het Formule-paneel zal de prijs in beide varianten tegelijk, met en zonder btw, zichtbaar zijn.",
            withVat: "Op het Formule-paneel zijn alle prijzen alleen zichtbaar inclusief BTW.",
            withoutVat: "In het Formule-paneel zijn alle prijzen alleen zichtbaar exclusief BTW."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synchroniseert gegevens met de sectie POS-info"
        },
        searchingPleaseWait: "Een ogenblik geduld, er wordt naar de beste match gezocht",
        setupSteps: {
            customData: "Aangepaste gegevens",
            machineType: "Machinetype",
            userPreferences: "Gebruiker voorkeuren"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Bij gebruik van geprofileerde waarden worden de meetresultaten herberekend om het filtereffect te verwijderen. Sta deze optie toe voor universele spectrometingen.",
            XRiteModelRM400: "Geen stuurprogramma's nodig.",
            datacolorDiagnosticTile: "Datacolor gebruikt diagnostische tegel",
            datacolorSilent: "Datacolor stil ",
            measureModes: "Select supported gloss levels.",
            model: "model ",
            simulationPath: "Pad naar het simulatiebestand. Standaard preset",
            spectroType: "OfficiÃ«le spectro-driver moet worden geÃ¯nstalleerd. Alleen Windows.",
            spectroTypeCom:
                "OfficiÃ«le spectro-driver moet worden geÃ¯nstalleerd. Pas op voor de gebruikte COM-poort. Zowel Windows als Linux.",
            spectroTypeDataColorReader:
                "De computer moet een Bluetooth-verbinding hebben. De spectro moet worden gekoppeld met de computer. Windows 10 met automatische update 2018 vereist.",
            spectroTypeMinolta2XXXd:
                "OfficiÃ«le spectro-driver moet worden geÃ¯nstalleerd. Pas op voor de gebruikte COM-poort. Zowel Windows als Linux.",
            spectroTypeNotSelected: "Selecteer uw spectromodel.",
            spectroTypeRM400: "Geen stuurprogramma's nodig.",
            spectroTypeSimulation:
                "Lab-waarden die nodig zijn om simulatieresultaten te verkrijgen. Zowel Windows als Linux.",
            spectroTypeXRite: "enkel Windows"
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "De instelling voegt een nieuwe gebruiker toe die kan inloggen op de software. De gebruiker kan een barcode krijgen toegewezen en kan worden ingesteld om automatisch in te loggen nadat de software is gestart.",
            assignedGroups:
                "Dit bepaalt tot welke gebruikersgroepen de gebruiker behoort. Verschillende gebruikersgroepen verdelen verschillende privileges.",
            availableGroups:
                "Dit bepaalt welke gebruikersgroepen er beschikbaar zijn voor de gebruiker. Verschillende gebruikersgroepen verdelen verschillende privileges.",
            loggedUserDelete: "De momenteel aangemelde gebruiker kan niet worden verwijderd."
        },
        visit: "Of ga naar",
        visitNoLicense: "Voor meer informatie, ga naar"
    },
    helpSettings: {
        customHelpLink: "Aangepaste Helpcentrum-link",
        helpSettings: "Help instellingen",
        message: "Bericht"
    },
    helper: {
        automaticallyCheckForUpdates: "Controleer automatisch voor updates",
        automaticallyDownloadUpdates: "Updates automatisch downloaden",
        automaticallyInstallNewDatabases: "Automatisch nieuwe databases installeren",
        automaticallyInstallUpdates: "Updates automatisch installeren",
        bugReport: "Fout rapport  ",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "Verzamelen",
        collectLogFiles: "Verzamel log bestanden",
        component: "Bestanddeel",
        content: "Inhoud",
        contentSize: "Inhoudsgrootte",
        download: "download",
        downloadLogFiles: "Download log bestanden",
        downloadingData: "Gegevens downloaden",
        everyHours: "Elke %{interval} uren",
        forceInstall: "Update forceren",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "Nieuwe versie",
        notConnected: "Helper is niet geconnecteerd",
        openBugReport: "Open fout rapportage",
        packageSize: "Verpakkingsgrootte",
        pleaseWait: "Even geduld, dit kan even duren.",
        send: "Stuur",
        sendBugReportToCustomerService: "Stuur fout rapport naar klantendienst",
        sendingReport: "Bezig met verzenden",
        subject: "Onderwerp"
    },
    helperDialog: {
        1: "U kunt controleren op software- of database-updates.",
        2: "Wilt u doorgaan met het downloaden van de updatepakketten?",
        3: "Doorgaan met de installatie van gedownloade updatepakketten?",
        10: "Controleren op software- en database-updates, even geduld ...",
        11: "Er is een update beschikbaar voor uw computer. Wilt u dit downloaden?",
        12: "Er zijn geen updates beschikbaar voor uw computer.",
        14: "Er is een fout opgetreden tijdens het controleren op updates. %{0}",
        15: "Zone-databases synchroniseren, even geduld ...",
        20: "Updatepakket wordt gedownload, even geduld ...",
        21: "Het gedownloade updatepakket wordt nu geverifieerd, even geduld ...",
        22: "Het downloaden van het updatepakket is mislukt. Wilt u het opnieuw proberen?",
        23: "Het downloaden van het updatepakket is mislukt (bestand is onjuist), wilt u het opnieuw proberen?",
        24: "Doorgaan met update-installatie?",
        25: "De installatie van de automatische update begint over %{0}",
        26: "Er is een update beschikbaar voor uw computer. Wilt u dit downloaden?",
        27: "Doorgaan met update-installatie?",
        40: "Toepassingen en services stoppen, een ogenblik geduld ...",
        41: "Nieuwe bestanden worden gekopieerd, even geduld ...",
        42: "Toepassingen en services starten, even geduld ...",
        43: "Software-update wordt voltooid, even geduld",
        44: "Uw software is succesvol bijgewerkt.",
        45: "Wilt u de installatie opnieuw proberen? Als u opnieuw probeert, zorg er dan voor dat softwarecomponenten momenteel niet in gebruik zijn.",
        46: "Opnieuw opstarten van pc is vereist om de wijzigingen te beÃ¯nvloeden, opnieuw opstarten wordt uitgevoerd in %{0}",
        999: "Interne fout opgetreden: %{0}",
        automaticInstallation: "Automatische update-installatie",
        btnAbort: "Afbreken",
        btnCancel: "Annuleer",
        btnCheckUpdate: "Controleer voor updates",
        btnContinue: "Ga door",
        btnDownloadUpdate: "Download update",
        btnInstallUpdate: "Installeer update",
        btnOk: "OK ",
        btnRetry: "Probeer opnieuw",
        btnSkip: "Sla over",
        checkingForUpdates: "Controleer voor updates",
        downloadingFailed: "Dowload mislukt",
        downloadingPackage: "Bezig met downloaden van updatepakket. even geduld aub",
        finishingUpdate: "Udpate afronden",
        installingUpdate: "Update installeren",
        internalError: "Interne fout",
        rebootRequired: "Opnieuw opstarten is vereist",
        startingComponents: "Softwarecomponenten starten",
        stoppingComponents: "Softwarecomponenten stoppen",
        synchronizingDatabases: "Zonedatabases synchroniseren",
        updateAvailable: "Update beschikbaar, selecteer componenten die moeten worden bijgewerkt",
        updateDownloaded: "Update is gedownload",
        updateFailed: "Update proces is mislukt",
        updateInstalled: "Update is geÃ¯nstalleerd",
        verificationFailed: "Verificatie van updatepakket is mislukt",
        verifyingPackage: "Gedownloade pakket verifiÃ«ren",
        yourSoftwareIsUpToDate: "Uw software is up to date",
        yourSoftwareVersion: "Uw softwareversie: %{0}"
    },
    importData: {
        abortImportingData: "Stop import",
        aborted: "Import is afgebroken.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Wilt u alle instellingen herstellen?",
        dataMissing: "Importeren mislukt omdat het bronbestand geen gegevens bevatte.",
        deleteImportedData: "Wis geÃ¯mporteerde data",
        encodingFile: "Bestandscodering",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Importeren mislukt omdat het bronbestand beschadigd lijkt te zijn.",
        fileMissing: "Importeren mislukt omdat het bronbestand niet bestaat.",
        format: "Ontwerp",
        formatPath: "Ontwerp opmaken",
        headerMissing: "Importeren mislukt omdat de header van het bestand ontbreekt.",
        import: "import ",
        importAborted: "Import onderbroken",
        importAborting: "Import wordt onderbroken",
        importFailed: "Het importeren is mislukt vanwege een onverwachte fout.",
        importLocalSettings: "Import Local Settings",
        importPrices: "Import prijzen",
        imported: "Succesvol geÃ¯mporteerd",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Wordt geÃ¯mporteerd",
        noFormatAvailable: "Geen ontwerp beschikbaar ",
        processing: "In verwerking",
        processingCustomFormulas: "Klant formules in verwerking",
        processingCustomers: "Klanten in verwerking",
        productsFile: "Product fiche",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Er wordt geÃ¯mporteerd.",
        unknownFormat: "Importeren mislukt omdat het bronbestand een onbekende indeling heeft.",
        userFormulasFile: "Bestand met gebruikersformules"
    },
    infoType: {
        baseDensity: "Basis Densiteit",
        baseMass: "Basis Massa",
        baseUfiCode: "Basis UFI-code",
        baseVolume: "Basis volume",
        batchNumbersTable: "Batchnummertabel",
        bfsGrade: "BFS Grade",
        colorLab: "Kleur Lab",
        colorRgb: "RGB kleur",
        colorRgbHex: "RGB Hex kleur",
        colorXyz: "Kleur xyz",
        colorantBatchNumbers: "Colorant batchnummer",
        colorantMass: "Kleur massa",
        colorantUfiCodes: "Colorant UFI-codes",
        colorantVolume: "Volume kleurpasta",
        formulaDate: "Formuledatum",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Meer formule informatie",
        formulaMoreInfoInternal: "Meer interne formule informatie",
        formulaMoreInfoPrint: "Meer formule print informatie",
        hbw: "HBW",
        isPackageGravimetric: "Is verpakking gravimetrisch",
        maxColorantMass: "Maximum toegestaan colorantgewicht",
        maxColorantVolume: "Maximum toegestaan colorantvolume",
        nominalMass: "Verpakking nominaal kleurstof hoeveelheid",
        nominalVolume: "Verpakking nominaal volume",
        overfillDetected: "Overpigmentatie vastgesteld",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Totale verf massa",
        totalPaintVolume: "Totaal Verf volume",
        ufiCodesTable: "UFI-codetabel",
        verifiedFormula: "Geverifieerde formule",
        yValue: "Y waarde"
    },
    initialTab: {
        favoriteFormulas: "Favoriete formules",
        lastDispensedFormulas: "Laatst gebruikte formules",
        searchNewFormula: "Nieuwe formule zoeken "
    },
    invalidBatchNumbersModal: {
        header: "Controleer colorant batchnummer",
        info: "Minimaal Ã©Ã©n canister is gevuld met (mogelijk) foutieve batch. Gebruik deze batch niet. Leeg het canister via het handmatig doseren.",
        unknownStatus: "Onbekende batchstatus"
    },
    keyWords: {
        action: "actieve gebruiker",
        add: "voe toe",
        addition: "toevoeging",
        additional: "extra",
        address: "adres",
        admin: "admin",
        advanced: "geavanceerd",
        after: "na",
        afterDispensing: "na dosering",
        alfa: "alfa",
        all: "allemaal",
        allow: "sta toe",
        alphabetically: "alfabetisch",
        amount: "hoeveelheid",
        api: "api",
        ask: "vraag",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "beschikbare prijs",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "basis",
        before: "voor",
        begin: "begin",
        bfs: "bfs",
        bottom: "onderaan",
        brand: "merk",
        brush: "borstel",
        bug: "bug",
        button: "knop",
        buy: "koop",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibratie",
        can: "blik",
        canHandling: "blik hanteren",
        canister: "canister   ",
        canisterFilling: "canister vulling",
        canisterLevels: "canister niveaus",
        canisters: "canisters",
        cap: "cap",
        center: "centrum",
        centre: "centrum",
        change: "wijziging",
        changelog: "changelog",
        channels: "kanalen",
        check: "Controleer",
        chunk: "brok",
        chunks: "brokken",
        city: "stad",
        clean: "schoon",
        cleaning: "schoon maken",
        clientIdentifier: "klant ID",
        close: "Sluit connectie",
        closest: "dichtst bijzijnd",
        code: "code",
        collect: "verzamelen",
        color: "kleur",
        colorLink3: "ColorLink3",
        colorPanel: "kleuren pallet",
        colorReader: "ColorReader",
        colorant: "pigment",
        colorantConsumption: "pigment verbruik ",
        colorantPrice: "pigment prijs",
        colorants: "pigmenten",
        colorix: "colorix",
        colour: "kleur",
        communication: "communicatie",
        compare: "vergelijk",
        competitive: "gelijkaardig",
        computer: "computer",
        config: "config",
        configuration: "configuratie",
        confirm: "bevestig",
        confirmation: "bevestiging",
        connection: "verbinding",
        contactPerson: "contact persoon",
        control: "controle",
        copies: "KopieÃ«n",
        corob: "corob",
        cost: "kost",
        country: "land",
        create: "creÃ«ren",
        currency: "munt eenheid",
        current: "huidige",
        custom: "op maat",
        customers: "klanten",
        daily: "dagelijks",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "datacolor",
        date: "datum",
        decimals: "decimalen",
        default: "standaard",
        delay: "vertraging",
        delete: "Verwijder markeringen",
        deletion: "schrapping",
        deltaE: "delta E",
        device: "toestel",
        devices: "toestellen",
        diagnosticTile: "diagnostische tegel",
        dialog: "dialoog",
        direct: "meteen",
        disconnect: "verbinding verbreken",
        discount: "korting",
        dispense: "doseer",
        dispenser: "dispenser",
        dispensing: "dosering",
        down: "naar beneden",
        download: "download",
        driver: "driver",
        dromont: "dromont",
        dspProxy: "DspProxy",
        edit: "bewerk",
        editor: "editor",
        email: "email ",
        error: "fout",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "vervaldatum",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "waaier",
        fastFluid: "Fast & Fluid",
        file: "bestand",
        fill: "vul",
        fillToMax: "vul tot maximum",
        find: "zoek",
        first: "eerst",
        flex: "flex",
        folder: "folder",
        formula: "formule",
        formulas: "formules",
        from: "van",
        fts5: "fts5",
        fullScreen: "volledig scherm",
        fullText: "hele tekst",
        fulltext: "hele tekst",
        g: "g",
        genericPricing: "generieke prijzen",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "hero",
        history: "geschiedenis",
        home: "home",
        host: "host",
        humidifier: "bevochtiger",
        iDD: "IDD",
        identification: "identificatie",
        image: "beeld",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "importeer",
        individually: "individueel",
        info: "info",
        information: "informatie",
        initial: "eerste",
        initialization: "initialisatie",
        initialize: "initialiseren",
        insert: "invoegen",
        install: "installeer",
        intellyPurge: "intelly purge",
        invalid: "ongeldig",
        ipAddress: "ip adres",
        italtinto: "Italtinto",
        items: "artikelen",
        keyboard: "toetsenbord",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk modus",
        l: "I",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "taal ",
        largo: "largo",
        last: "laatst",
        lenteq: "Lenteq",
        levels: "niveaus",
        license: "lisentie",
        light: "light",
        limit: "limiet",
        link: "link",
        linux: "linux",
        load: "laden",
        lock: "vergrendel",
        logFiles: "logboek bestanden ",
        logic: "logica  ",
        logo: "logo",
        lower: "lager",
        machine: "machine",
        machineConfiguration: "machine configuratie ",
        machineManagement: "machinebeheer",
        machineName: "machine naam",
        main: "hoofd",
        maintenance: "onderhoud",
        manual: "manueel ",
        manualAddition: "manuele toevoeging",
        manualDispensing: "manuele dosering",
        manualScan: "manuele scan",
        margins: "marges",
        markups: "markups",
        mass: "massa",
        match: "match",
        measure: "meten ",
        measurement: "meting",
        measurementUnits: "meeteenheden",
        melody: "melodie",
        message: "boodschap",
        minimal: "minimaal",
        minolta: "minolta",
        minus: "minus",
        minutes: "minuten",
        misura: "misura",
        ml: "ml ",
        mode: "modus",
        model: "model ",
        modification: "aanpassing",
        modify: "aanpassen ",
        monthly: "maandelijks",
        moreInfo: "meer informatie",
        movableTable: "verplaatsbare tafel ",
        move: "verplaats ",
        music: "muziek ",
        myOrders: "mijn bestellingen ",
        name: "naam ",
        naming: "benaming",
        nano: "nano",
        navigation: "navigatie",
        new: "nieuw",
        nextDriver: "nextdriver",
        night: "nacht",
        nixPro: "nix pro",
        notes: "notities",
        notification: "notificatie",
        number: "nummer ",
        off: "uit",
        open: "open",
        order: "bestelling",
        ordering: "bestelling",
        overfill: "te vol",
        overview: "overzicht",
        overwrite: "overschrijven ",
        own: "eigen",
        pCPDriver: "PCPDriver",
        package: "verpakking",
        packagePrice: "verpakkingsprijs",
        packages: "verpakkingen ",
        panels: "panelen",
        parameter: "parameter",
        path: "pad",
        pc: "pc ",
        phone: "telefoon",
        phoneNumber: "telefoon nummer",
        picture: "afbeelding",
        place: "plaats",
        placement: "plaatsing",
        plug: "plug ",
        plugger: "plugger",
        plugging: "Inpluggen",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "verkooppunt",
        popUp: "pop up",
        pos: "Verkooppunt ",
        present: "huidige",
        preview: "voorbeeld",
        price: "prijs",
        priceExport: "prijs export",
        priceGroup: "prijs groep",
        priceImport: "prijs import",
        prices: "prijzen",
        pricing: "prijszetting",
        primaryCurrency: "primaire valuta",
        print: "print",
        printer: "printer",
        printing: "printen",
        problem: "probleem",
        product: "product ",
        productPrice: "product prijs",
        profiledValues: "geprofileerde waarden",
        punch: "pons",
        puncher: "puncher",
        punching: "ponsen",
        purge: "purgeer ",
        purgeType: "purgeer type",
        purgeVolume: "purgeer volume",
        quality: "kwaliteit",
        quick: "snel ",
        quickTint: "snel tint",
        rM: "RM ",
        raise: "verhogen",
        rcc: "rcc",
        reader: "lezer",
        reboot: "herstart",
        receive: "te ontvangen",
        recirculate: "recirculeren",
        recirculation: "recirculatie",
        redlike: "Redlike",
        refill: "hervul",
        registration: "registratie",
        regular: "regelmatig",
        removal: "verwijdering ",
        remove: "verwijder   ",
        report: "rapporteer",
        reset: "reset",
        resolution: "resolutie",
        restart: "herstart",
        rgb: "rgb",
        rights: "rechten ",
        rounding: "afronding",
        rules: "regels",
        sanTint: "Santint",
        save: "sla op",
        scale: "schaal ",
        scan: "scan",
        scope: "rijkwijdte",
        screen: "scherm",
        screensaver: "screensaver",
        search: "zoek ",
        secondaryCurrency: "secundaire valuta",
        select: "selecteer",
        selectedFormula: "Selected formula",
        sell: "verkoop ",
        sensor: "sensor ",
        serialNumber: "serie nummer",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service actie",
        serviceActions: "service acties ",
        serviceSoftware: "service software",
        serviceWindow: "service venster",
        settings: "instellingen",
        shelf: "bliktafel",
        shortcuts: "bnelkoppelingen",
        shot: "shot",
        show: "toon ",
        shutDown: "afsluiten ",
        shutdown: "afsluiten ",
        silent: "stil ",
        simple: "gemakkelijk",
        simulation: "simulatie",
        size: "grootte",
        skip: "overslaan",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software leverancier",
        sort: "sorteer",
        sound: "geluid",
        spectro: "spectro",
        spectrophotometer: "spectro meter",
        speed: "snelheid",
        split: "splits",
        start: "start",
        startup: "startup",
        statistics: "statistieken",
        status: "status",
        stir: "roer",
        stirring: "roeren",
        street: "straat",
        support: "ondersteuning",
        surcharge: "toeslag",
        tab: "tabblad ",
        tabs: "tabbladen toestaan",
        task: "taak ",
        template: "sjabloon",
        testing: "testen",
        time: "tijd ",
        tintingManagementCenter: "tinting management center",
        to: "naar beneden",
        toDispense: "te doseren",
        tolerance: "tolerantie",
        top: "top ",
        total: "totaal ",
        translation: "vertaling",
        turnOff: "sluit af",
        turntable: "draaitafel",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "eenheid",
        up: "omhoog",
        update: "update",
        url: "url ",
        user: "gebruiker",
        userGroups: "gebruiker groepen",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "BTW",
        validate: "valideer",
        validation: "validatie",
        version: "versie",
        virtual: "virtueel ",
        volume: "volume",
        weekly: "wekelijks",
        window: "venster",
        windows: "vensters",
        with: "met ",
        without: "zonder ",
        xRite: "X-rite",
        xrite: "Xrite",
        yValue: "Y waarde ",
        zipCode: "post code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Licentie activeren",
        activateNewLicense: "Activeer nieuwe licentie",
        checkLicenseKey: "Licentiesleutel controleren",
        companyId: "Bedrijfs-ID",
        contactPerson: "Contactpersoon",
        copy: "Kopie",
        country: "Land",
        emptyCity: "Stad is vereiste informatie",
        emptyCountry: "Land is vereiste informatie",
        emptyName: "Winkel naam is vereiste informatie",
        enterIdentificationKeys: "Voer uw identificatie gegevens in",
        expirationDate: "Vervaldatum %{dateTime}",
        fillRegistration: "Voer registratiegegevens in",
        insertLicense: "Voer de gegenereerde sleutel in voor offline-activering",
        invalidEmail: "Email ingave is ongeldig",
        invalidPhone: "Telefoon ingave is ongeldig",
        itemsMarkedasterisk: "(Items gemarkeerd met een asterisk moeten worden ingevuld)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Tijdelijke licentie",
        licenseActivated: "Licentie geactiveerd",
        licenseStatus: "Licentie status",
        licenseWillExpire: "Uw licentie verloopt over %{dayCount} dagen",
        licenseWillExpireOneDay: "Uw licentie vervalt in %{dayCount} dagen",
        machineInformation: "Machine informatie",
        noLicenseAvailable: "Geen licentie beschikbaar",
        noProductsForKey: "Er zijn geen producten beschikbaar voor de vermelde identificatiesleutels.",
        pointOfSale: "Verkooppunt",
        producer: "Fabrikant",
        reactivate: "Reactiveer",
        reactivateLicense: "Reactivate license",
        region: "Regio",
        registerLicense: "KopieÃ«r het activeringsverzoek en ga naar:",
        registrationForm: "Registratie formulier",
        selectProduct: "Product selecteren",
        serialNumber: "Serienummer",
        skipNewLicense: "wenst u een nieuwe lisentie te activeren, klip op sla over",
        unlimitedLicense: "Onbeperkte licentie",
        userId: "Gebruikers-ID",
        uuid: "Licentie-ID",
        versionDetails: "Versie details",
        versionScope: "Versiebereik",
        versionType: "Versie type",
        zip: "Postcode"
    },
    login: {
        authenticate: "Authentiseren",
        logIn: "Aanmelden",
        loginAs: "Log in als andere gebruiker",
        messages: {
            incorrectUsername: "Gebruikersnaam of wachtwoord is onjuist."
        },
        password: "Wachtwoord",
        username: "Gebruikersnaam"
    },
    machineActionHistory: {
        actionHistory: "Actiegeschiedenis"
    },
    machineErrors: {
        channel: "Circuit",
        code: "Code",
        machineErrors: "Machinefouten",
        noMachineErrors: "Er zijn momenteel geen machine fouten ",
        resetErrors: "Fouten resetten"
    },
    machineSettings: {
        action: "Actie",
        addAutotask: "Stel autotask in",
        autoCanisterIn: "Automatische invoer canister",
        autoCanisterOut: "Automatische uitvoer canister",
        automaticRefill: "Automische vulling",
        autotaskSettings: "Autotask instellingen",
        backupConfiguration: "Configuratie back-up dispenser",
        brushMaintenance: "Borstel onderhoud",
        capMaintenance: "Cap onderhoud",
        checkCanisterBeforeDispense: "Controleer blik voor dosering",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: 'Controleer minimale doseerhoeveelheid van de coloranten"',
        checkOverfill: "Controleer",
        checkTotalCntAmounts: "Controleer de totale hoeveelheid colorant voor de basisverf",
        cleanAll: "Maak allen schoon",
        computerReboot: "computer herstart",
        computerShutdown: "Computer afsluiten",
        connectMachine: "Machine aansluiten",
        days: "Dagen",
        daysOfMonth: "Dagen van de maand",
        devices: "Apparaten",
        disabled: "Niet actief",
        dispenseAndPurge: "Doseer en purgeer",
        dispenseOnly: "Enkel doseren",
        dispenserCleaning: "Doseerder schoonmaak",
        dispensingWithErrorsEnabled: "Dosering toestan ondanks validatiefout",
        editAutotask: "Pas autotask aan",
        firstRun: "First run",
        hours: "Uren",
        humidifier: "Bevochtiger",
        humidifierWaterLevelMaintenance: "Onderhoud waterniveau bevochtiger",
        machineConfigurationNoCanisters: "De machine configuratie bevat geen canisters.",
        machineName: "Naam machine",
        machineSettings: "Instellingen machine",
        manualPuncher: "Manuele ponseerder",
        minDispensedAmount: "Minimum doseer hoeveelheid",
        minutes: "Minuten",
        nextRun: "Volgende run",
        noAutotasksSet: "Geen autotasks ingesteld",
        noDataAvailable: "Geen data beschikbaar",
        noMachine: "Machine is niet aangesloten",
        onStart: "Op start",
        plugger: "Plugger",
        postpone: "Stel uit",
        puncher: "Blik pons",
        purgeAll: "Purgeer alles",
        purgeOnly: "Enkel purgeren",
        recirculateAll: "Hercirculeer alles",
        recirculateChannels: "Hercircurculeer kanalen",
        recirculationSpeed: "Hercirculeer snelheid",
        recirculationTime: "Hercirculeer tijd",
        refillAll: "Vul alles aan",
        refillCanisters: "Vul canisters",
        runAt: "Dagelijks om",
        runDefinedDaysAt: "Bepaalde dagen om",
        runEvery: "Doe alles",
        runInDays: "Doe per dag",
        serialNum: "Serienummer",
        settingsMachine: "Machine-instellingen",
        smartPurgeAll: "Smart Purgeer alles",
        smartPurgeChannels: "Smart Purgeer kanalen",
        smartPurgeRules: "Smart purgeer regels",
        startType: "Begintype",
        stirAll: "Roer alles",
        stirCanisters: "Roer canisters",
        stirringSpeed: "Roer snelheid",
        stirringTime: "Roer tijd",
        switchPlateMaintenance: "Vervang onderhouds plateau",
        theCurrentlySelectedMachine: "De machine die op dit moment is geselecteerd",
        threshold: "Drempel",
        turntable: "Beweegbare tafel",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Volume",
        weekdays: "Weekdagen"
    },
    mainTab: {
        acceptedFormula: "Geaccepteerde formule",
        addBuildingSite: "Add building site",
        addToFavorites: "Toevoegen aan favorieten",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Een of meer pigmenten zijn ongeldig",
        dispensedPackages: "Gedoseerde verpakkingen",
        dispensingInProgress: "Doseren bezig",
        dispensingIsAborted: "Doseren is gestopt",
        dispensingIsNotAvailable: "Doseren is niet mogelijk",
        dispensingProgress: "%{done} van %{all} ",
        editColorant: "Kleurpasta bewerken",
        editNote: "Notitie bewerken",
        findCompetitiveColor: "Probeer concurrerende kleur te vinden",
        forceDispensing: "Forceer doseren",
        formulaInvalidColorants: "Formule bevat ongeldige kleurpasta's: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Verborgen kleurenwaaiers",
        hiddenProducts: "Verborgen producten",
        historicalFormulas: "Historische formules",
        lowerDeltaNumber: "Een lager Deltagetal hoe nauwkeuriger de overeenkomst",
        machineError: "Machine storing",
        machineIsBusy: "Machine is bezig",
        machineNotConnected: "Machine is niet aangesloten",
        manualColorantAddition: "Manuele toevoeging pigment",
        modifiedFormula: "Formule is gewijzigd",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "Nieuwe RGB wordt niet nauwkeurig gemeten, het is slechts indicatief",
        noBaseAvailable: "Geen basis beschikbaar",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Geen kleurpasta's",
        noCustomer: "Geen klant",
        noCustomers: "Geen klanten beschikbaar",
        noDispenseNotesAvailable: "Geen opmerkingen voor doseren beschikbaar",
        noFormulaAvailable: "U heeft een combinatie zonder formule gekozen!",
        noFormulaSelected: "Geen formule geselecteerd",
        noInternalNotesAvailable: "Er zijn geen interne notities beschikbaar",
        noNotesAvailable: "Geen opmerkingen beschikbaar",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Geen verpakking geselecteerd",
        noProductAvailable: "No product is available",
        noResultsFound: "Geen resultaten gevonden",
        openLocalFile: "Openen vanuit lokale database",
        openOnlineFile: "Openen vanaf het internet",
        order: "Bestelling",
        orderingIsNotAvailable: "Bestellen is niet beschikbaar",
        originalColor: "Originele kleur",
        overAvailableLevel: "Over toegestane niveau",
        package: "Verpakking",
        packageIsRequired: "verpakking is vereist",
        packaging: "verpakking",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Afdrukken niet beschikbaar",
        productFiles: "Product bestanden",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Normale prijs",
        resetFormulaData: "Nieuwe formule",
        rgbOnlyIndicative: "RGB weergave is indicatief",
        saveAsCustom: "Opslaan als",
        saveToStatsIsNotAvailable: "Opslaan in geschiedenis is niet beschikbaar",
        searchForCheaper: "Zoek naar goedkoper",
        selectFromCompetitive: "U kunt een kleur kiezen uit de concurrende kleuren",
        specialPrice: "Speciale prijs",
        specialPriceVip: "Speciale VIP-prijs",
        splitFormula: "Splits formule op",
        withVAT: "Inclusief BTW",
        withoutVAT: "Exclusief BTW"
    },
    marginSettings: {
        allBases: "Alle basissen",
        allProducts: "Alle producten",
        editMargin: "Marge bewerken",
        marginAndDiscountWarning: "U moet de prijsberekeningsoptie instellen voor het gebruik van marges en kortingen.",
        marginSettings: "Instellingen marge",
        marginsFor: "Marges voor",
        markupColorants: "Winstmarge pigment",
        sizeOfPackage: "Afmetingen van de verpakking",
        valueBase: "Basis waarde",
        valueColorant: "Waarde colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Pas pigment unit aan",
        payAttention: "Opgelet!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filter kleurenwaaier",
            formulasOverLimit: "Ongeveer %{count} resultaten. Geef meer karakters in.",
            foundFormulas: "%{count} formules gevonden",
            help: "Help",
            helpText:
                "Typ b.v. '%{filter}' om formules te zoeken die beginnen met '%{formula}', product dat begint met '%{product}' en kleurenwaaier '%{fandeck}'.",
            productFilter: "Productfilter",
            searchInFormulas: "Zoeken in formules",
            typeMore: "Geef meer karakters in"
        },
        menu: {
            actionHistory: "Geschiedenis",
            additionalFormulaTab: "Extra formule tabblad",
            advancedSettings: "Geavanceerde instellingen",
            autotaskSettings: "Autotask instellingen",
            availableDatabases: "Beschikbare databases",
            availablePrices: "Beschikbare prijzen",
            bugReport: "Fout rapport",
            canisterBarcodes: "Canister barcodes",
            canisterDispensingLogic: "Doseer logica",
            canisterFilling: "Vullen canister",
            canisterSettings: "Canister instellingen",
            clientServerSettings: "Klant-/serverconnectie",
            closing: "Sluiten",
            color: "Kleur",
            colorModification: "Kleur aanpassing",
            colorPanel: "Instellingen kleurenpaneel  ",
            colorRepresentation: "Kleurweergave en gegevens",
            colorSearch: "Kleur zoeken",
            colorant: "Pigment",
            colorantConsumption: "Pigment verbruik",
            colorantPricing: "Prijs kleurpasta",
            colorantRefillHistory: "Geschiedenis van colorant bijvullen",
            competitiveSearch: "Competitief zoeken in kleur",
            connections: "Verbindingen",
            currency: "Valuta",
            customData: "Aangepaste gegevens",
            database: "Database",
            databaseCheck: "Database check",
            databaseConnection: "Verbinding databank",
            defaultValues: "Standaard waarden",
            devices: "Toestellen",
            dispensingHistory: "Doseer geschiedenis",
            dispensingSettings: "Doseringsinstellingen",
            driverSettings: "Driverinstellingen",
            environment: "Omgeving",
            environmentConfiguration: "Omgevingsinstellingen",
            environmentalSettings: "Omgevingsinstellingen",
            favorites: "Favorieten",
            fileTransfer: "Deso bestandsoverdracht",
            formatting: "Opmaak",
            formula: "Formula",
            formulaData: "Gegevens",
            formulaModification: "Formula modification",
            formulaPanels: "Formulepanelen",
            formulaSettings: "Instellingen formule",
            formulaUnit: "Formule-eenheid",
            generalSearch: "Algemeen zoeken",
            globalSettingsSearch: "algemene instellingen zoeken",
            helpItems: "Help instellingen",
            importAndExport: "Import en export",
            importAndExportData: "Aangepaste gegevens importeren",
            importCustomData: "Import gegevens",
            initialFormulaTab: "Tabblad initiÃ«le formule",
            interfaceSettings: "Interface-instellingen",
            keyboardShortcuts: "Toetsenbord shortcuts",
            language: "Taalinstellingen",
            languageSettings: "Taal instellingen",
            layout: "Lay-out",
            license: "Licentie",
            licenseData: "Licentiegegevens",
            licenseIdentification: "Licentie-identificatie",
            licenseStatus: "Licentie status",
            licenseSupplier: "Licentie leverancier",
            licenseVersion: "Licentie versie",
            localData: "Lokale gegevens",
            machine: "Info machine",
            machineActions: "Acties machine",
            machineAndDevices: "Machine & apparaten",
            machineManagement: "Machinebeheer",
            machineSettings: "Instellingen machine",
            mainSettings: "Hoofdinstellingen",
            maintenance: "Onderhoud",
            marginAndDiscount: "Marge en korting",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Navigatie Items",
            newFormulaWindow: "Formule",
            orderSearch: "Zoekfunctie bestellingen",
            orderSettings: "Bestelinstellingen",
            packageSurcharge: "Pakkettoeslag ",
            popUps: "Pop-ups",
            posInfo: "POS informatie",
            price: "Prijsinstellingen",
            priceManagement: "Prijsbeheer",
            priceSettings: "Prijsinstellingen",
            pricingOptions: "Prijs opties",
            printSettings: "Afdrukken",
            productPricing: "Product prijzen",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Handmatig doseren",
            rccConfig: "RCC-instellingen",
            rccConnection: "RCC-verbinding",
            rccSettings: "RCC-instellingen",
            refillSettings: "Instellingen bijvullenÅ¯",
            refillingLogic: "Logica bijvullen",
            registration: "Registratie",
            searchSettings: "Zoek instellingen",
            serverPlugins: "Server plug-ins",
            serviceActions: "Acties onderhoud",
            settings: "Instellingen",
            simplifiers: "Vereenvoudigers",
            singleActions: "Enkele acties",
            smartPurgeRules: "Slimme purgeerregels",
            softwareOptions: "Software opties",
            spectroSettings: "Instellingen Spectro",
            statistics: "Statistiek",
            switchToFrontdesk: "Schakel over naar Frontdesk",
            switchToFullRedlike: "Overschakelen naar %{name}",
            switchToLight: "Overschakelen naar %{name}",
            switchToMachine: "Schakel over naar Machine",
            tabs: "Tabbladen & pop-ups",
            testBarcodes: "Test barcodes",
            updateOptions: "Update-opties",
            userManagemenet: "Gebruikersbeheer",
            visibleUnits: "Zichtbare units"
        },
        navBar: {
            barcode: "Barcode",
            help: "Help",
            hideItems: "Verberg producten / kleurenwaaiers"
        },
        notificationPanel: {
            noNotifications: "Geen nieuwe meldingen"
        },
        tabBar: {
            closeActive: "Actieve sessies sluiten",
            closeAll: "Alles sluiten",
            closeAllExceptActive: "Sluit alles behalve actieve sessies",
            customFormula: "Custom Formula",
            dispensingHistory: "Doseer geschiedenis",
            favorites: "Favorieten",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Wijs toe",
        assignment: "Toewijzing",
        createdDate: "Aanmaakdatum",
        finishDispensing: "Dosering afwerking",
        foundInOrders: "Gevonden in orders",
        inactiveDatabase: "Formule is uit een inactieve of onbekende database %{0}",
        inactiveUnknownDatabase: "Formule is uit een inactieve of onbekende database",
        newOrderReceived: "U heeft een nieuwe order ontvangen!",
        noOrderSelected: "Geen order geselecteerd",
        release: "Vrijgeven",
        status: {
            accepted: "Geaccepteerd",
            canceled: "Geannuleerd",
            created: "Aangemaakt",
            done: "Uitgevoerd",
            partlyDone: "Gedeeltelijk uitgevoerd",
            preparing: "Voorbereiden",
            unknown: "Onbekend"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adres",
        contactName: "Contactnaam",
        contactPerson: "Contactpersoon",
        identification: "Identificatie",
        machineInformation: "Machine informatie",
        pos: "Winkel",
        secondAddress: "Alternatief adres",
        shopIdentification: "Winkel identificatie",
        shopName: "Winkel naam",
        url: "Internet adres",
        zipCode: "Postcode"
    },
    priceTypeList: {
        priceBasePurchase: "Basis aankoopprijs",
        priceBaseSell: "Basis verkoopprijs",
        priceBaseSellFull: "Verkoop volle prijs voor basis",
        priceCntPurchase: "Aankoopprijs kleurpasta",
        priceCntPurchaseByColorantName: "Kostprijs voor pigment %{0}",
        priceCntPurchaseByName: "Aankoopprijs kleurpasta per naam",
        priceCntSell: "Verkoopprijs kleurpasta",
        priceCntSellByColorantName: "Verkoopprijs voor pigment %{0}",
        priceCntSellByName: "Verkoopprijs kleurpasta per naam",
        priceCntSellFull: "verkoop volle prijs voor colorants",
        priceCntSellFullByColorantName: "verkoop volle prijs voor %{0} colorant",
        priceCntSellFullByName: "Verkoop volle prijs voor alle verpakkingen",
        priceGroupBarcode: "Prijs groep barcode",
        priceMarginAll: "Marge voor alle verpakkingen",
        priceMarginPerPkg: "Marge voor Ã©Ã©n verpakking",
        priceSellPriceAll: "Verkoopprijs voor all verpakkingen",
        priceSellPricePerKg: "Verkoopprijs per kilogram",
        priceSellPricePerL: "Verkoopprijs per liter",
        priceSellPricePerPkg: "Verkoopprijs voor Ã©Ã©n verpakking",
        priceSurchargeAll: "Toeslag voor alle verpakkingen",
        priceSurchargePerPkg: "Toeslag voor Ã©Ã©n verpakking",
        priceTintPurchaseAll: "Tint kostprijs voor alle verpakkingen",
        priceTintPurchasePerPkg: "Tint kostprijs voor Ã©Ã©n verpakking",
        priceTintSellFullAll: "Tint verkoopprijs voor alle verpakkingen",
        priceTintSellFullAllPerPackage: "Tint verkoopprijs voor Ã©Ã©n verpakking",
        priceTotalPurchaseAll: "Total aankoopprijs voor alle verpakkingen",
        priceTotalPurchasePerKg: "Totale aankoopprijs per kilogram",
        priceTotalPurchasePerL: "Totale aankoopprijs per liter",
        priceTotalPurchasePerPkg: "Totale aankoopprijs voor Ã©Ã©n verpakking",
        priceTotalSellFullAll: "Totale verkoopprijs voor alle verpakkingen",
        priceTotalSellFullPerKg: "Totale verkoopprijs per kg",
        priceTotalSellFullPerLiter: "Totale verkoopprijs per liter",
        priceTotalSellFullPerPackage: "Totale verkoopprijs per verpakking"
    },
    pricing: {
        allBases: "Alle basissen",
        allPackages: "Alle verpakkingen",
        backup: "Backup",
        basesOfProduct: "Basissen van %{productName}",
        colorantPricing: "Kleurpasta prijs",
        export: "Exporteer",
        import: "Importeer",
        packagePricing: "Prijs verpakking",
        packageSurcharge: "Toeslag verpakking",
        packages: "Verpakkingen",
        packagesOfProduct: "Verpakkingen van %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Prijs groep per liter",
        priceGroups: "Prijs groepen",
        pricePerLiter: "Prijs per liter",
        productPricing: "Product prijs",
        purchasePrice: "Aankoopprijs",
        purchasePricePerLiter: "Aankoopprijs per liter",
        sellPrice: "Verkoopprijs",
        surcharge: "Toeslag"
    },
    print: {
        adminRightsRequired: "Beheerdersrechten zijn vereist om een nieuw sjabloon te bewerken of te maken",
        allowAutomaticPrint: "Sta automatische print toe",
        allowPrintAfterDispensing: "Sta print toe na doseren",
        allowPrintBeforeDispensing: "Sta print toe voor doseren",
        automaticPrint: "Automatisch printen toestaan",
        choosePrinter: "Selecteer printer",
        chooseSettings: "Instellingen bewerken",
        chooseTemplate: "Selecteer sjabloon",
        copies: "Kopie",
        createTemplate: "Maak een sjabloon",
        createTemplateHint: "Maak een nieuw sjabloon. Sla deze op in de map met sjablonen en herstart RCC",
        defaultPrinter: "Printer",
        defaultSettings: "Standaar instellingen",
        defaultTemplate: "Standaard sjabloon",
        editTemplate: "Sjabloon bewerken",
        editTemplateHint: "Bewerk %{name}. Wijzigingen zullen zichtbaar zijn nadat RCC opnieuw is opgestart.",
        noEditTemplate: "Geen sjabloon om te bewerken",
        noPrinterSelected: "Geen printer gesecteerd",
        noPrintersAvailable: "Geen printers beschikbaar",
        noTemplateSelected: "Geen sjabloon geselecteerd",
        noTemplatesAvailable: "Geen sjablonen beschikbaar",
        numberOfCopies: "Aantal kopieÃ«n",
        openTemplateEditor: "Sjablooneditor openen",
        printAfterDispensing: "Print na doseren",
        printAsImage: "Print als afbeelding",
        printBeforeDispensing: "Print voor doseren",
        printOnRequest: "Print op verzoek",
        printOptions: "Printer opties",
        printPagesAfterDispensing: "Aantal kopies na doseren",
        printPagesBeforeDispensing: "Aantal kopies voor doseren",
        printPreview: "Afdruk voorbeeld",
        printSettings: "Printer instellingen",
        printTaskLinkVariable: "Link naar variabele",
        printVariable: "Afdruk variabel",
        printerName: "Printernaam",
        printerOptions: "Printeropties",
        printerSettings: "Printerinstellingen",
        quickTintTemplate: "Snelle dosering sjabloon",
        setDefaultPrinter: "Stel standaardprinter in",
        setDefaultTemplate: "Stel standaardsjabloon in",
        setQuickTintTemplate: "Stel snelle dosering sjabloon in",
        showPreviewDialogBeforePrint: "Toon afdrukvoorbeeld voor afdrukken",
        template: "Sjabloon",
        templateName: "Sjabloonnaam",
        templateSettings: "Sjabloon instellingen"
    },
    printTemplate: {
        baseCode: "Basis code",
        baseName: "Basis naam",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Klant Stad",
        customerEmail: "Klant email",
        customerName: "Klant naam",
        customerPhone: "Klant telefoonnummer",
        customerStreet: "Klant straat",
        customerZipCode: "Klant postcode",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS graad",
        orderQrCode: "QR Code",
        packageOrderCount: "Aantal pakketbestellingen",
        posAddress: "Verkooppunt adres",
        posAddressSecond: "Verkooppunt adres 2",
        posCity: "Verkooppunt stad",
        posContact: "Verkooppunt contact",
        posEmail: "Verkooppunt email",
        posPhone: "Verkooppunt telefoonnummer",
        posUrl: "Verkooppunt URL",
        posZipCode: "Verkooppunt post code",
        priceBasePurchaseWithTax: "Kostprijs basis verf BTW inclusief",
        priceBaseSellWithTax: "Verkoopprijs basis verf BTW inclusief",
        priceCntPurchaseWithTax: "Kostprijs pigmenten BTW inclusief",
        priceCntTotalSellWithTax: "Verkoopprijs pigmenten BTW inclusief",
        priceMarginAllWithTax: "Marge voor alle verpakkingen BTW inclusief",
        priceMarginPerPkgWithTax: "Marge voor Ã©Ã©n verpakking BTW inclusief",
        priceSellPriceAllWithTax: "Verkoopprijs voor alle verpakkingen BTW inclusief",
        priceSellPricePerKgWithTax: "Verkooprijs per kg BTW inclusief",
        priceSellPricePerLWithTax: "Verkoopprijs per liter BTW inclusief",
        priceSellPricePerPkgWithTax: "Verkoopprijs voor Ã©Ã©n verpakking BTW inclusief",
        priceSurchargeAllWithTax: "Toeslag voor alle verpakkingen BTW inclusief",
        priceSurchargePerPkgWithTax: "Toeslag voor Ã©Ã©n verpakking BTW inclusief",
        priceTintPurchaseAllWithTax: "Kleur kost voor alle verpakkingen BTW inclusief",
        priceTintPurchasePerPkgWithTax: "Kleur kost voor Ã©Ã©n verpakking BTW inclusief",
        priceTotalPurchaseAllWithTax: "Kleur kost voor alle verpakkingen BTW inclusief",
        priceTotalPurchasePerKgWithTax: "Totale kostprijs per kg BTW inclusief",
        priceTotalPurchasePerLWithTax: "Totale kostprijs per liter BTW inclusief",
        priceTotalPurchasePerPkgWithTax: "Totale kostprijs voor Ã©Ã©n verpakking inclusief BTW",
        productAltName: "Product",
        recipeInline: "Recept"
    },
    products: {
        bases: "Basisverven",
        numberOfProducts: "Aantal producten",
        packagesFor: "Verpakkingen voor",
        sizeOfPackage: "Afmetingen van de verpakking"
    },
    purgeModal: {
        purgeAll: "Alles doorspoelen",
        purgeAllChannels: "Purgeer alle kanalen",
        purgeVolume: "Doorspoel hoeveelheid",
        startPurge: "Doorspoelen starten"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Doseren bezig",
        dispensingIsNotAvailable: "Doseren is niet beschikbaar",
        machineNotConnected: "Machine is niet verbonden",
        noColorantsSelected: "Geen kleurpasta's geselecteerd",
        noPrinterAvailable: "Print kan niet worden uitgevoerd, geen printer beschikbaar",
        noTemplateAvailable: "Print kan niet worden uitgevoerd, geen sjabloon beschikbaar",
        overMaxCanisterSize: "ÃÃ©n of meerdere kleurpastaniveaus zijn incorrect"
    },
    quickTintSettings: {
        alphabetically: "Alfabetisch",
        byCanister: "Per canister",
        closeAfterDispensing: "Sluit na dosering",
        closeBeforeDispensing: "Sluit voor dosering",
        quickTintSettings: "Instellingen snel doseren",
        sorting: "Sorteren",
        windowClosingRules: "Regels voor het sluiten van vensters"
    },
    rccButtons: {
        abort: "Afbreken",
        all: "Alle",
        cancel: "Annuleren",
        continue: "Doorgaan",
        help: "Help",
        ignore: "Negeren",
        no: "Nee",
        noToAll: "Niet op alle",
        ok: "OK",
        postpone: "Uitstellen",
        resume: "Hervatten",
        retry: "Opnieuw proberen",
        skip: "Overslaan",
        yes: "Ja",
        yesToAll: "Ja op alles"
    },
    rccDialog: {
        98: "Controleer basis %{0} met de barcode.",
        99: "Plaats basis %{0} en bevestig (klik OK)",
        100: "Verfmengmachine geeft foutmelding. Foutmeldingen resetten?",
        101: "Verfmengmachine geeft foutmelding. Verdergaan is niet mogelijk.",
        102: "Resetten mislukt. Verdergaan is niet mogelijk.",
        103: "Formule bevat ongeldige kleurpasta: %{0}",
        104: "Formule bevat ongeldige kleurpasta's: %{0}",
        105: "Kleurpasta: %{0} valt onder het waarschuwingsniveau",
        106: "Kleurpasta's: %{0} valt onder het waarschuwingsniveau",
        107: "Kleurpasta: %{0} valt onder kritiek niveau",
        108: "Kleurpasta's: %{0} vallen onder kritiek niveau",
        109: "Plaats blik",
        110: "Plaats basisverfblik: %{0} voor formule: %{1}",
        111: "Blik verwijderen",
        112: "Blik ponsen?",
        113: "Foutmeldingen resetten, wachten a.u.b.",
        114: "Bliktafel  verplaatsen, wachten a.u.b.",
        115: "Blik ponsen, wachten a.u.b.",
        116: "Formule doseren %{0}, wachten a.u.b.|Verpakking: %{1} van %{2}|Product: %{3}|basisverf: %{4}|Formaat blik: %{5}",
        117: "Formule doseren %{0}, wachten a.u.b.|Verpakking: %{1} van %{2}|Product: %{3}|basisverf: %{4}|Formaat blik: %{5}",
        118: "Doseren, wachten a.u.b.|Verpakking: %{0} van %{1}",
        119: "Doseren, wachten a.u.b.|Verpakking: %{0} van %{1}",
        120: "Doseren annuleren, wachten a.u.b.",
        121: "Scan barcode kleurpasta",
        122: "Scan barcode basisverfblik|Product: %{0}|basisverf: %{1}|Formaat blik: %{2}",
        123: "Doseerproces werd afgebroken. Wilt u het proces voortzetten?",
        124: "Foutmelding verfmengmachine %{0} : %{1}. Wilt u het doseerproces voortzetten?",
        125: "Zorg ervoor dat u het blik neemt dat u net hebt gebruikt",
        126: "Gebruik een nieuw blik want het doseerproces begint opnieuw",
        127: "Kleurpasta: %{0} valt onder de minimale doseerhoeveelheid. Wilt u het proces voortzetten ondanks deze waarschuwing?",
        128: "Kleurpasta's: %{0} valt onder de minimale doseerhoeveelheid. Wilt u het proces voortzetten ondanks deze waarschuwing?",
        129: "De geselecteerde formule voldoet niet aan de overloopregel, totale hoeveelheid kleurpasta's: %{0} %{1}, maximaal toegestane hoeveelheid kleurpasta's: %{2} %{3}. Wilt u het proces voortzetten ondanks deze waarschuwing?",
        130: "Verfmengmachine geeft foutmelding. Foutmeldingen resetten?",
        131: "Verfmengmachine geeft foutmelding. Verdergaan is niet mogelijk.",
        132: "Resetten mislukt. Verdergaan is niet mogelijk.",
        133: "Formule voor doorspoelen is leeg, verdergaan is niet mogelijk",
        134: "Formule voor doorspoelen bevat items die niet gedoseerd kunnen worden. Wilt u verdergaan?",
        135: "Plaats blik voor doorspoelen",
        136: "Verwijder blik voor doorspoelen",
        137: "Foutmeldingen resetten, wachten a.u.b.",
        138: "Bliktafel verplaatsen, wachten a.u.b.",
        139: "Doorspoelen, wachten a.u.b.",
        140: "Doorspoelen, wachten a.u.b.",
        141: "Doorspoelen annuleren, wachten a.u.b.",
        142: "Blik ontbreekt, controleer of het blik goed geplaatst werd",
        143: "Purgeer formule bevat items die niet kunnen gepurgeerd worden, wilt u toch doorgaan?",
        144: "Plaats blik voor purgeren",
        145: "Voorbereiding, gelieve te wachten",
        146: "Afwerking, gelieve te wachten",
        150: "Reinigen, wachten a.u.b.",
        151: "Reinigen, wachten a.u.b.",
        152: "Reinigen annuleren, wachten a.u.b.",
        160: "Recirculeren, wachten a.u.b.",
        161: "Recirculeren, wachten a.u.b.",
        162: "Recirculeren annuleren, wachten a.u.b.",
        170: "Roeren, wachten a.u.b.",
        171: "Roeren, wachten a.u.b.",
        172: "Roeren annuleren, wachten a.u.b.",
        180: "Verbinding met de verfmengmachine tot stand brengen, wachten a.u.b.",
        181: "Verbinding met de verfmengmachine is niet mogelijk %{0}: %{1}",
        182: "Connectie met de verfmengmachine is niet mogelijk. Zie logbestanden voor meer informatie",
        183: "Dispenser mist pigmenten %{0} die in de database gedefinieerd zijn",
        184: "Dispenser mist pigmenten %{0} die in de database gedefinieerd zijn",
        185: "Connectie met de verfmengmachine afsluiten, wachten a.u.b.",
        190: "Sluit het servicevenster om verder te gaan",
        200: "Resetten, wachten a.u.b.",
        201: "Harde reset, wachten a.u.b.",
        202: "Initialiseren, wachten a.u.b.",
        203: "Foutmeldingen resetten, wachten a.u.b.",
        205: "Autocap openen, wachten a.u.b.",
        206: "Autocap sluiten, wachten a.u.b.",
        207: "Autocap in beweging, wachten a.u.b.",
        210: "Ponzen, wachten a.u.b.",
        211: "Pluggen, wachten a.u.b.",
        215: "Bliktafel omhoog bewegen, wachten a.u.b.",
        216: "Bliktafel omlaag bewegen, wachten a.u.b.",
        217: "Bliktafel in beweging, wachten a.u.b.",
        220: "Draaitafel verplaatsen naar hervulpositie: %{0}, wachten a.u.b.",
        221: "Draaitafel verplaatsen naar basispositie, wachten a.u.b.",
        222: "Draaitafel verplaatsen, wachten a.u.b.",
        230: "Verfmengmachine bezig, wachten a.u.b.",
        240: "Hervullen canister %{0}",
        241: "Hervullen canister %{0}",
        242: "Positioneer canister: %{0} (%{1}) naar hervulpositie",
        243: "Vul canister %{0} bij door gebruik te maken van barcode",
        244: "Vul canister %{0} bij door gebruik te maken van barcode",
        250: "Verwijder borstel container, maak schoon en vul met water volgens instructies",
        251: "Plaats borstel container terug",
        254: "Autocap wordt geopend",
        255: "Maak autocap schoon volgens instructies",
        256: "Bevestig na schoonmaak en autocap terug in positie",
        257: "Sluiting autocap",
        260: "Verwijder de schakelplaat en maak deze schoon",
        261: "Plaats de schakelplaat terug",
        265: "Maak machine schoon met doek en verwijder gemorste kleurpasta's of andere vloeistoffen",
        266: "Bevestig wanneer klaar",
        270: "Hervul de bevochtiger water container en bevestig wanneer gedaan",
        271: "Hervul de bevochtiger water container en bevestig wanneer gedaan",
        272: "Water niveau is nog steeds laag, controleer opnieuw",
        273: "Water niveau is nog steeds laag, controleer opnieuw",
        274: "Controleer het water niveau in de bevochtiger container",
        275: "Gelieve even te wachten",
        280: "Reboot van de computer",
        281: "Afsluiting van de computer",
        300: "Basis blik niet aanwezig, zorg ervoor dat het blik in juiste positie staat",
        301: "Voorbereiding, wachten aub",
        302: "Afwerken, wachten aub",
        303: "De formule kan niet worden gedoseerd omdat deze pigment bevat: %{0} wat de maximale doseerhoeveelheid is die is gedefinieerd voor het blik",
        304: "De formule kan niet worden gedoseerd omdat deze pigmenten bevat: %{0} die meer zijn dan de maximale doseringen die voor canisters zijn gedefinieerd",
        305: "Pigment: %{0} kan niet in Ã©Ã©n keer worden verdeeld, wilt u de formule splitsen?",
        306: "Pigment: %{0} kan niet in Ã©Ã©n keer worden verdeeld, wilt u de formule splitsen?",
        307: "Pigment: %{0} wordt niet gedoseerd door de dispenser, wilt u doorgaan en het handmatig toevoegen?",
        308: "Pigmenten: %{0} wordt niet gedoseerd door de dispenser, wilt u doorgaan en ze handmatig toevoegen?",
        309: "Geselecteerde formule is leeg, gebruik basis blik zoals het is",
        310: "Er kan geen pigment worden gedoseerd, bereid het basisblik voor handmatige toevoeging van pigment",
        311: "Verwijder basis blik en bereid manuele inkleuring voor",
        312: "Voeg handmatig %{0} %{1} colorant toe: %{2}, bevestig wanneer u klaar bent",
        313: "Doseer manuele formule",
        314: "De geselecteerde formule overtreedt de overvulregel, totaal aantal kleurstoffen: %{0} %{1}, maximaal toegestane hoeveelheden kleurstoffen: %{2} %{3}. Wilt u ondanks deze waarschuwing doorgaan?",
        315: "Scan of typ UFI-code van het basis blik",
        316: "Scan of typ de UFI-code van het basisblik|product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Taak automatisch purgeren wordt gestart",
        401: "Taak automatisch purgeren wordt gestart",
        405: "Borstel container heeft onderhoud nodig",
        406: "Borstel container heeft onderhoud nodig",
        410: "Automatisch onderhoud van de cap wordt gestart",
        411: "Automatisch onderhoud van de cap wordt gestart",
        415: "Schakelaarplaat moet worden schoongemaakt",
        416: "Schakelaarplaat moet worden schoongemaakt",
        420: "Doseerder moet schoongemaakt worden",
        421: "Doseerder moet schoongemaakt worden",
        425: "Aanvullen van canisters wordt gestart",
        426: "Aanvullen van canisters wordt gestart",
        430: "Computer reboot werd ingesteld",
        431: "Computer reboot werd ingesteld",
        435: "Computer afsluiting werd ingesteld",
        436: "Computer afsluiting werd ingesteld",
        440: "Machine schoonmaak werd ingesteld",
        441: "Machine schoonmaak werd ingesteld",
        445: "Machine recirculatie werd ingesteld",
        446: "Machine recirculatie werd ingesteld",
        450: "Machine roeren werd ingesteld",
        451: "Machine roeren werd ingesteld",
        990: "Foutmelding verfmengmachine %{0} : %{1}. Wilt u opnieuw proberen?",
        991: "Interne foutmelding: %{0}",
        200000001: "Plaats blik",
        200000002: "Blik verwijderen",
        200000003: "Hoeveelheid voor %{0} onder de minimale doseerhoeveelheid, op eigen risico verdergaan?",
        200000004: "Hervullen %{0}"
    },
    rccDriverSettings: {
        databasePath: "Database pad",
        dispenser: "Doseer",
        dispenserConfigurationFile: "Dispenser configuratie bestand",
        driverPath: "Driver pad",
        extensionPath: "Extension pad",
        folder: "Map",
        formulaPath: "Formula pad",
        host: "host",
        iddPath: "IDD-configuratiebestand",
        italtintoPath: "ItalTinto-configuratiebestand",
        lldPath: "LLD-pad",
        machineType: "Type machine",
        noMachineAvailable: "Geen machine beschikbaar",
        protocolVersion: "Protocol versie",
        rccDriverSettings: "Driverinstellingen",
        resultPath: "Resultaten pad",
        save: "Instellingen opslaan",
        saveSettingsWarning:
            "Waarschuwing! Wijzigingen in deze sectie kunnen een storing veroorzaken bij de verfmengmachine",
        serviceSwPath: "Service Software pad",
        simulationPath: "Simulatiepad"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Sta manuele toevoeging van pigment toe",
        ask: "Vraag",
        canHandlingOptions: "Blikherkenning opties",
        checkCanBeforeDispense: "Controleer blik voor dosering",
        checkOverfill: "Controleer op overvulling",
        colorantBatchNumbers: "Colorant batchnummer",
        colorantPackageValidation: "Alleen validatie van kleurstofpakketten",
        disable: "Uitsckakelen",
        dispenseInvalidColorants: "Doseer ongeldige colorants",
        dispensingOptions: "Doseer-opties",
        enable: "Inschakelen",
        enableUserIdentification: "Gebruikersidentificatie",
        fullValidation: "volledige validatie",
        machineAccuracyWarning: "Waarschuwing voor machine nauwkeurigheid",
        machineOptions: "Machine opties",
        machineUnit: "Machine eenheid",
        minimalDispenseAmount: "Minimale doseergrootte",
        placeCanSensor: "Bliksensor",
        placeCanSensorDelay: "Vertraging bliksensor",
        rccMachineSettings: "Instellingen machine",
        refillBarcodeValidation: "Barcode validatie bijvullen",
        refillBarcodeValidationCanisterAndColorant: "Canister en colorant verpakking valideren",
        refillBarcodeValidationColorant: "Alleen colorant verpakking valideren",
        refillSettings: "Instellingen bijvullen",
        removeCanSensor: "Verwijder bliksensor",
        removeCanSensorDelay: "Verwijder uitstel bliksensor",
        save: "Instellingen opslaan",
        sec: "sec.",
        skipPlaceCanDialog: "Dialoogvenster Plaats overslaan",
        skipRemoveCanDialog: "Overslaan verwijderen kan dialoogvenster",
        splitFormula: "Splits formule op",
        tmcEnabled: "TMC inschakelen",
        ufiCode: "UFI-code",
        validateBarcodeBaseCan: "Scan barcode basisverfblik",
        validateBarcodeRefill: "Valideer barcode voor het vullen",
        validateColorantsDuringInit: "Valideer pigmenten tijdens initialisatie"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Mengmachine is bezig taken uit te voeren",
        addLevel: "NIVEAU TOEVOEGEN",
        addManually: "Handmatig toevoegen",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) heeft geen barcode toegewezen.",
        cancel: "ANNULEREN",
        dispenseFormula: "Doseer formule",
        dispenserIdle: "De machine is stand-by",
        dispenserIsBusy: "De machine is bezig",
        dispenserIsIdle: "De machine is stand-by",
        dispenserIsReady: "De machine is klaar voor opdrachten",
        dispensingFormula: "Formule doseren",
        errorCode: "Fout code",
        explanation: "Uitleg",
        fillToMax: "Vul tot maximaal niveau",
        finished: "Afgewerkt",
        inProgress: "Bezig",
        machineIsReady: "Machine is klaar",
        moveToFill: "Verplaats om te vullen",
        noMachineDialog: "Geen machine verbonden",
        of: "van",
        packageSize: "Formaat verpakking",
        placeBaseCan: "Plaats basis blik",
        pleaseCheckYourMachineConnection: "Controleer uw machine verbinding.",
        pleaseRefill: "Hervullen a.u.b.",
        solution: "Oplossing",
        subErrors: "Sub fouten",
        timeToEnd: "Resterende tijd",
        tintingFormula: "Doseer formule",
        tintingPleaseWait: "Machine aan het doseren, wachten a.u.b.",
        validateBaseCan: "Valideer basis blik",
        waiting: "wachten"
    },
    rccSettigns: {
        rccSettigns: "RCC-connectie",
        rccUrl: "URL RCC"
    },
    rccSpectroDialog: {
        100: "Uw toestel verbinden via Bluetooth. Zorg ervoor dat Bluetooth ingeschakeld is en dat uw toestel werkt.",
        101: "Het toestel werd niet gedetecteerd. Wilt u opnieuw proberen?",
        110: "Zorg ervoor dat Nano verbonden is en druk op de startknop van het toestel om te beginnen",
        111: "Nano werd niet gedetecteerd. Wilt u opnieuw proberen?",
        112: "Nano ontkoppelen, 10 seconden wachten, opnieuw verbinden en verdergaan",
        120: "verbinding met uw toestel, gelieve te wachten",
        121: "Instrument is niet gedetecteerd. Wil je het opnieuw proberen?",
        200: "Zet het toestel op de zwarte tegel en ga verder of druk op de knop van het toestel",
        201: "Zet het toestel op de zwarte tegel en ga verder",
        202: "Zet het toestel op de zwarte tegel en druk op de knop van het toestel",
        205: "Zet het toestel op de witte tegel en ga verder of druk op de knop van het toestel",
        206: "Zet het toestel op de witte tegel en ga verder",
        207: "Zet het toestel op de witte tegel en druk op de knop van het toestel",
        210: "Zet het toestel op de diagnosetegel en ga verder of druk op de knop van het toestel",
        211: "Zet het toestel op de diagnosetegel en ga verder",
        212: "Zet het toestel op de diagnosetegel en druk op de knop van het toestel",
        215: "Sluit het deksel van het toestel en ga verder of druk op de knop van het toestel",
        216: "Sluit het deksel van het toestel en ga verder",
        217: "Sluit het deksel van het toestel en druk op de knop van het toestel",
        220: "Zet het toestel op de nultegel en ga verder of druk op de knop van het toestel",
        221: "Zet het toestel op de nultegel en ga verder",
        222: "Zet het toestel op de nultegel en druk op de knop van het toestel",
        224: "Plaats het instrument op het kalibratietegel en ga verder of druk op de instrumentknop",
        225: "Plaats het instrument op het kalibratietegel en ga verder",
        226: "Plaats het instrument op het kalibratietegel en druk op de instrumentknop",
        227: "Plaats het instrument op het kalibratietegel en druk op de instrumentknop",
        295: "BeÃ«indig kalibratie in het drivervenster",
        296: "Spectrofotometer is niet aangesloten, wilt u er verbinding mee maken?",
        297: "Voorbereiden op kalibratiestap, wachten a.u.b.",
        298: "Kalibratie, wachten a.u.b.",
        299: "BeÃ«indigen kalibratiestap, wachten a.u.b.",
        300: "Zet het toestel op de kleurstaal en ga verder of druk op de knop van het toestel",
        301: "Zet het toestel op de kleurstaal en ga verder",
        302: "Zet het toestel op de kleurstaal en druk op de knop van het toestel",
        303: "Spectrofotometer is niet gekalibreerd, wilt u doorgaan met kalibreren?",
        304: "Spectrofotometer is niet aangesloten, wilt u er verbinding mee maken?",
        390: "Select measure mode",
        395: "BeÃ«indig meting in het drivervenster",
        397: "Voorbereiden op meting, wachten a.u.b.",
        398: "Meten, wachten a.u.b.",
        399: "Meten beÃ«indigen, wachten a.u.b.",
        498: "Meting laden, wachten a.u.b.",
        499: "Alle metingen laden, wachten a.u.b.",
        900: "Foutmelding toestel %{0} : %{1}. Wilt u het opnieuw proberen?",
        901: "Interne foutmelding: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "De computer moet een Bluetooth-verbinding hebben. De spectro moet worden gekoppeld aan de computer. Windows 10 met 2018 automatische update vereist.",
        DatacolorSilent:
            "Bij gebruik van de stille modus worden Datacolor-vensters direct weergegeven in %{name}. In deze vensters kunnen spectro-parameters niet worden gewijzigd.",
        DatacolorUseDiagnosticTile: "Het gebruik van diagnostische tegels verbetert de meetkwaliteit.",
        comPort: "Com Poort",
        diagnosticTile: "Gebruik Datacolor diagnosetegel",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "Model",
        noSpectroAvailable: "Er is geen spectro beschikbaar",
        rccSpectroSettings: "Instellingen Spectro",
        save: "Instellingen opslaan",
        silent: "Datacolor is stand-by",
        simulationPath: "Simulatiepad",
        spectroType: "Spectrotype",
        useProfiledValues: "Gebruik geprofileerde waarden"
    },
    recirculateChannels: {
        recirculateAllChannels: "Alle circuits recirculeren",
        recirculateChannels: "Recirculatie circuit",
        recirculatingSpeed: "Recirculatiesnelheid",
        recirculatingTime: "Recirculatietijd",
        startRecirculating: "Start recirculeren"
    },
    redlikeLight: {
        finishPreviousSteps: "Graag vorige stap voltooien",
        searchBySpectro: "Zoek met Spectro",
        searchFormula: "Zoek formule",
        selectBase: "Selecteer basis",
        selectColor: "Selecteer kleur",
        selectCustomer: "Selecteer klant",
        selectFandeck: "Selecteer kleurenwaaier",
        selectPackage: "Selecteer verpakking",
        selectProduct: "Selecteer product",
        startSelectFandeck: "Start om de kleurenwaaier te selecteren",
        startSelectProduct: "Start om het product te selecteren",
        stepByStepProgress: "U kunt stap voor stap doorgaan",
        typeHereToSearch: "Type hier om te zoeken",
        typeToFilter: "Type om te filteren"
    },
    restartModal: {
        computerNeedsRestart: "Computer moet opnieuw opgestart worden",
        notCompletelyTranslated:
            "Taal aanpassing vraagt om herstarten. Sommige stukken van de software zullen niet allemaal vertaald zijn.",
        restartIsRequired: "De software moet opnieuw worden opgestart nadat de wijzigingen zijn aangebracht.",
        softwareNeedsRestart: "%{name} herstart nodig!"
    },
    searchPanel: {
        basePlaceholder: "of typ een basisnaam",
        baseStartPlaceholder: "Begin met het typen van basisnaam",
        colorCodeNamePlaceholder: "of typ een formule code/naam",
        colorCodeNameStartPlaceholder: "Begin met het typen van een code/formulenaam",
        colorCodePlaceholder: "of voer een formulecode in",
        colorCodeStartPlaceholder: "Begin voer een formulecode in",
        colorNameCodePlaceholder: "of typ een formule naam/code",
        colorNameCodeStartPlaceholder: "Begin met het typen van een formulenaam/code",
        colorNamePlaceholder: "of voer een formulenaam in",
        colorNameStartPlaceholder: "Begin voer een formulenaam in",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "of voer een naam van een kleurenwaaier in",
        fandeckStartPlaceholder: "Begin voer een naam van een kleurenwaaier in",
        formulaByColor: "Formule per kleur",
        noResultsFound: "Geen resultaten gevonden",
        packagePlaceholder: "of typ een pakketnaam",
        packageStartPlaceholder: "Begin met het typen van pakketnaam",
        productPlaceholder: "of voer een productnaam in",
        productStartPlaceholder: "Begin een productnaam te typen",
        standard: "Standaard",
        typeFandeckToFilter: "Typ hier om te filteren op kleurenwaaier",
        typeProductToFilter: "Typ hier om te filteren op productnaam"
    },
    sendOrderModal: {
        customNote: "Aangepaste opmerkingen",
        noCompatibleServers: "Geen compatibele servers zijn beschikbaar in uw netwerk",
        orderOverview: "Order overzicht",
        selectTargetMachine: "Selecteer doelmachine",
        sendOrder: "Verstuur opdracht",
        sendOrderTo: "Uw opdracht wordt verzonden naar %{serverName}",
        targetMachine: "Doelmachine"
    },
    server: {
        computerId: "Computer ID",
        ip: "IP",
        selectServer: "Selecteer een van de beschikbare servers",
        server: 'Server" '
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Actieve server-plugins",
        currentlyActive: "De momenteel actieve plugins",
        plugin: "Plugin",
        pluginName: "Plugin naam",
        statusActive: "Actief",
        statusInactive: "Niet actief"
    },
    serviceActionsSettings: {
        canisterLevel: "Canisterniveau",
        capClose: "Sluiten",
        capMiddle: "Midden",
        capOpen: "Open",
        cleanAllChannels: "Alle nozzles reinigen",
        cleanChannels: "Nozzles schoonmaken",
        computer: 'Computer"',
        computerReboot: "Computer heropstart",
        computerShutdown: "Computer afsluiten",
        connectMachine: "Machine verbinden",
        general: "Algemeen",
        initialize: "Initialiseren",
        noMachineIsConnected: "Geen machine verbonden",
        plug: "Afdichter",
        plugger: "Waterhouder",
        punch: "Pons",
        puncher: "Blikpons",
        purgeChannels: "Circuit doorspoelen",
        recirculate: "Recirculeren",
        recirculateAllChannels: "Alle circuits recirculeren",
        recirculateChannels: "Recirculatie circuit",
        serviceActions: "Acties onderhoud",
        setCanisterLevel: "Canisterniveau instellen",
        shelfDown: "Bliktafel omlaag",
        shelfUp: "Bliktafel omhoog",
        showServiceWindow: "Toon servicevenster",
        smartPurgeAllChannels: "Smart purgeer alle kanalen",
        smartPurgeChannels: "Smart purgeer kanalen",
        startErrorReset: "Begin met fouten resetten",
        startHardReset: "Begin harde reset",
        startReset: "Begin reset",
        stirAllCanisters: "Roer alle canisters",
        stirCanisters: "Roer canisters",
        stirCanistersMore: "Roer canisters"
    },
    spectroMode: {
        eggshell: "Ei glans",
        flat: "Mat",
        gloss: "Glans",
        matt: "Mat",
        matte: "Mat",
        pearl: "Pearl",
        satin: "Zijdeglans",
        selectGlossLevel: "Vergelijk het kleurmonster met de glansschaal en selecteer het glansniveau",
        semiGloss: "Halfglans"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibreren",
        calibrateInstrument: "Fotospectrometer kalibreren",
        connectDevice: "Verbind apparaat",
        connectedTo: "Verbonden met",
        connectingDevice: "Uw toestel verbinden",
        deselectAll: "Deselecteer alles",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Uw toestel is niet gekalibreerd",
        eraseResult: "Wis resultaat",
        filter: "Filter",
        foundInFormulas: "Gevonden in formules",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Het instrument moet gekalibreerd worden",
        manualInput: "Handmatige invoer",
        measure: "Meten",
        measurementResult: "Resultaat meting",
        noFilters: "Geen filters beschikbaar",
        noFormulas: "Geen formules gevonden",
        noSelectedSpectro: "Geen spectro geselecteerd",
        notSelected: "Niet geselecteerd",
        pressConnectButton: "Controleer de verbinding met uw toestel en druk op de knop verbinden",
        searchFormulas: "Formules zoeken",
        selectSpectro: "Selecteer spectro",
        showDetails: "Toon details",
        skipCalibration: "Sla kalibreren over",
        spectroIsConnected: "Spectro is verbonden",
        spectroIsReady: "De spectro is klaar",
        spectroReady: "Het apparaat is klaar voor verdere taken",
        startCalibrateNow: "Start kalibratie van apparaat",
        startMeasureText: "Uw toestel is gekalibreerd, u kunt de meting starten",
        tolerance: "Delta E",
        toleranceOfDevitation: "Delta E (CIE 2000) tolerantie"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Aangepast %{1} %{2}",
        deleteSelectedRecords: "Geselecteerde records verwijderen",
        exportHistory: "Exporteer geschiedenis",
        finishFormula: "Vervolledig formule",
        foundInFormulas: "Gevonden in formules",
        hideHiddenRecords: "Toon geen verborgen records",
        hideSelectedRecord: "Verberg geselecteerde record",
        historicalFormula: "Formule historie",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Herstel geselecteerde record",
        showAllRecords: "Toon alle records",
        standardFormula: "Standard formula",
        unknownFormula: "Onbekende formulering"
    },
    stirCanisters: {
        selectCanisters: "Selecteer canisters",
        startStirring: "Start roeren",
        stirAllCanisters: "Roer alle canisters",
        stirCanisters: "Roer canisters",
        stirringSpeed: "Roersnelheid",
        stirringTime: "Roertijd"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Voeg colorant verpakking toe aan de voorraad",
        addPackagesToStock: "Verpakkingen toevoegen aan de voorraad",
        addedToStock: "Toegevoegd aan de voorraad",
        allDatabases: "Alle databases",
        checkStockPackageInventory:
            "Als u een verpakking uit de voorraad heeft gebruikt, controleer dan of uw voorraad.",
        clearAllItems: "Alle items wissen",
        colorantInventory: "Colorant voorraad",
        colorantsStockInventory: "Colorant voorraad",
        confirmSendingOrder: "Bevestig de bestelling",
        consumptionPrediction: "Verbruiksvoorspelling voor de komende %{weeks} weken",
        createOrder: "Maak bestelling aan (%{sum})",
        expirationDate: "Houdbaarheidsdatum",
        inDelivery: "Onderweg",
        manualOrder: "Handmatige order",
        manualOrderProgress: "Stap %{step}/%{total}",
        noPackagesFoundInStockForColorant: "Er zijn geen verpakkingen op voorraad van deze colorant.",
        onStock: "In voorraad",
        orderSummary: "Overzicht van de bestelling",
        prediction: "Voorspelling",
        removePackageFromStock: "%{colorantName} verpakking uit de voorraad halen",
        removePackageNameFromStock: "Wilt u Ã©Ã©n %{packageName} verpakking uit de voorraad halen?",
        scanBarcodeOrSelectColorant: "Scan barcode van colorant verpakking of selecteer handmatig de juiste colorant",
        selectPackageToRemove: "Selecteer verpakking om te verwijderen",
        sendConfirmed: "Bevestig verzenden",
        setAmountsByPrediction: "Stel aantal in op basis van voorspelling",
        sortByColorantName: "Sorteer op colorant",
        sortByOrderNeed: "Sorteer op basis van behoefte",
        sortByStockLevel: "Sorteer op voorraadniveau",
        toOrder: "Te bestellen"
    },
    testBarcode: {
        noItemAssigned: "Geen artikel aan barcode toegekend %{code}",
        pleaseScanBarcode: "Scan de barcode van basis verf, product, verpakking of andere",
        testBarcodes: "Test barcodes"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Laatste",
        next: "Volgende"
    },
    ufiCodeModal: {
        currentStatus: "Huidige status",
        detailedInfoForColorant: "Gedetailleerde informatie voor colorant %{colorantName}",
        userSetUfiCode: "Door gebruiker ingestelde UFI-code, huidige waarde"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Basis UFI-codevalidatie",
        confirmColorantRefilling: "Colorant bijvullen bevestigen",
        enableUfiCodes: "Inschakelen UFI-codes",
        printUfiCode: "Print als de hoeveelheid colorant boven",
        printUfiCodePercentage: "Print percentage als de hoeveelheid colorant boven ",
        scanOrTypeUfiCode: "Scan of typ UFI-code",
        scanOrTypeUfiCodeOfBase: "Scan of typ UFI-code van basisblik ",
        ufiCodesByPercentage: "Gebruik UFI-codes op basis van percentage ",
        ufiCodesFromDatabase: "Gebruik UFI-codes van de database",
        ufiCodesFromLastFilling: "Gebruik UFI-codes van de laatste vulling"
    },
    userSettings: {
        addUser: "Voeg gebruiker toe",
        assignedUserGroups: "Toegewezen klant groepen",
        availableUserGroups: "Beschikbare klant groepen",
        barcode: "Barcode",
        confirmNewPassword: "Bevestig nieuw wachtwoord",
        editPassword: "Pas wachtwoord aan",
        editUser: "Pas gebruiker aan",
        enableAutoLogin: "Schakel automatisch inloggen in",
        newPassword: "Nieuw wachtwoord",
        noChange: "Er hoeft geen wijziging te worden opgeslagen",
        oldPassword: "Oud wachtwoord",
        password: "Wachtwoord",
        passwordsDoNotMatch: "Wachtwoorden komen niet overeen",
        restoreUser: "Deze gebruiker werd verwijderd, wilt u hem terugzetten?",
        userGroup: "User Group",
        userGroups: "Gebruikers groepen",
        userManagement: "Gebruikersbeheer",
        userSettings: "Gebruiksinstellingen",
        username: "Gebruikersnaam",
        usernameIsMissing: "Gebruikersnaam ontbreekt."
    },
    warningMissingDataModal: {
        continue: "Dezelfde gegevens ontbreken, wil je doorgaan?",
        notFoundBase:
            "Dit product is niet beschikbaar. Bevestig en zorg ervoor dat u een compatibele product uit het schap haalt of annuleer deze bestelling.",
        notFoundProduct:
            "Dit product is niet beschikbaar. Bevestig en zorg ervoor dat u een compatibel product uit het schap haalt of annuleer deze bestelling."
    },
    weekdays: {
        friday: "Vrijdag",
        monday: "Maandag",
        saturday: "Zaterdag",
        sunday: "Zondag",
        thursday: "Donderdag",
        tuesday: "Dinsdag",
        wednesday: "Woensdag"
    },
    welcome: {
        availableDatabase: "Server kan geen verbinding maken met de database. Controleer uw databaseconfiguratie.",
        availableDatabaseLocalError:
            "Fout tijdens connecteren met lokael database ( verkeerd bestand, foutief wachtwoord )",
        availableDatabaseLocalMissing: "Lokaal database bestand niet aanwezig",
        availableDatabaseLocalUpdate: "Lokale database heeft update nodig naar nieuwere versie",
        availableDatabaseMainAndLocalError:
            "Fout tijdens verbinding maken met hoofd-en lokale databases (verkeerd bestand, incorrect wachtwoord)",
        availableDatabaseMainAndLocalMissing: "Hoofd- en lokale databasebestanden ontbreken",
        availableDatabaseMainAndLocalUpdate:
            "Hoofd- en lokale databases moeten worden bijgewerkt naar de nieuwere versie",
        availableDatabaseMainError: "Fout tijdens verbinden met hoofddatabase (verkeerd bestand, incorrect wachtwoord)",
        availableDatabaseMainMissing: "Hoofddatabase bestand niet gevonden",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Hoofddatabase moet worden bijgewerkt naar de nieuwere versie",
        closing: "Software is aan het afsluiten",
        compatibility: "Controleer de versie van uw server. Uw client is alleen compatibel met server %{0} of hoger.",
        compatibilityCheck: "Compatibiliteitscontrole bezig",
        compatibilityDatabase: "Uw database is niet compatibel met de server. Controleer uw databaseconfiguratie.",
        connectingServer: "Bezig met verbinding server %{ip}",
        databaseCompatibility: "Uw database is niet compatibel met uw huidige software",
        databasesCompatibility: "Uw database is niet compatibel met uw huidige software",
        licenseVerification: "Controleren van licentie bezig",
        loading: "Laden",
        lostConnection: "De verbinding met de server werd verbroken",
        moduleMessage:
            "Besteed aandacht aan moduleselectie, omdat toekomstige wijziging van module alleen beschikbaar zal zijn voor geprivilegieerde gebruikers.",
        refresh: "Verversen",
        restoring: "Verbinding herstellen",
        selectModule: "Selecteer een van de beschikbare modules.",
        stopUpdate: "Stop update",
        updateDatabase: "Update database",
        updatingDatabase: "Database is aan het updaten",
        updatingDatabases: "Database is aan het updaten",
        updatingWarning: "De databasestructuur wordt bijgewerkt, even geduld.",
        updatingWarningInfo: "Let op: Het sluiten van dit venster kan zorgen voor onherstelbare schade aan de database."
    }
};
